// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/assets/fonts/Wotfard/Wotfard-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../public/assets/fonts/Wotfard/Wotfard-SemiBold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../public/assets/fonts/Wotfard/Wotfard-Medium.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../public/assets/fonts/Wotfard/Wotfard-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../public/assets/fonts/Wotfard/Wotfard-Light.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Martel+Sans:wght@300;400;700;800&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* eslint-disable unknownAtRules */

/* ! tailwindcss v3.4.3 | MIT License | https://tailwindcss.com */

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden] {
  display: none;
}

body{
  font-family: wotfard, Martel Sans, sans-serif;
    font-size: 1rem;
    line-height: 1.5rem;
}

a:visited{
  --tw-text-opacity: 1;
  color: rgb(0 79 78 / var(--tw-text-opacity));
}

[type='radio']{
  border-width: 2px;
  --tw-border-opacity: 1;
  border-color: rgb(227 242 242 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(0 79 78 / var(--tw-text-opacity));
  --tw-ring-offset-width: 0px;
}

[type='radio']:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
.container{
  width: 100%;
}
@media (min-width: 640px){

  .container{
    max-width: 640px;
  }
}
@media (min-width: 768px){

  .container{
    max-width: 768px;
  }
}
@media (min-width: 1024px){

  .container{
    max-width: 1024px;
  }
}
@media (min-width: 1280px){

  .container{
    max-width: 1280px;
  }
}
@media (min-width: 1536px){

  .container{
    max-width: 1536px;
  }
}
.container{
  max-width: 100%;
}
@media (min-width: 640px){

  .container{
    max-width: 640px;
  }
}
@media (min-width: 768px){

  .container{
    max-width: 768px;
  }
}
@media (min-width: 1024px){

  .container{
    max-width: 1024px;
  }
}
@media (min-width: 1280px){

  .container{
    max-width: 1170px;
  }
}
/* ------------ Inputs ------------ */
.form-group{
  position: relative;
  display: flex;
  flex-direction: column;
}
.form-group:focus{
  outline-width: 0px;
}
html {
    overflow: scroll;
    overflow-x: hidden;
  }
::-webkit-scrollbar {
    width: 0; /* Remove scrollbar space */
    background: transparent; /* Optional: just make scrollbar invisible */
  }
/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
    background: #ff0000;
  }
input:-webkit-autofill::first-line{
  font-family: wotfard, Martel Sans, sans-serif;
    font-size: 16px;
    font-weight: 400;
}
select:-webkit-autofill::first-line{
  font-family: wotfard, Martel Sans, sans-serif;
    font-size: 16px;
    font-weight: 400;
}
.form-group label {
    pointer-events: none;
    transform: translate(0, 15px) scale(1);
    transform-origin: top left;
    transition: 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
    position: absolute;
    left: 12px;
    font-size: 1rem;
    line-height: 1.5rem;
    color: rgba(0,79,78,0.6);
  }
.form-group input {
    font-size: 16px;
    line-height: 1;
    transition: 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
    height: 56px;
    position: relative;
    width: 100%;
    border-radius: 0.375rem;
    border-width: 0px;
    --tw-bg-opacity: 1;
    background-color: rgb(227 242 242 / var(--tw-bg-opacity));
    padding-left: 0.75rem;
    padding-right: 0.75rem;
    padding-top: 1rem;
    padding-bottom: 1rem;
    font-size: 1rem;
    line-height: 1.5rem;
    outline: 2px solid transparent;
    outline-offset: 2px;
  }
.form-group input:focus{
  --tw-border-opacity: 1;
  border-color: rgb(14 109 108 / var(--tw-border-opacity));
}
.form-group :disabled {
    background-color: #e9e9e9;
  }
.form-group select {
    font-size: 16px;
    line-height: 1;
    transition: 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
    height: 56px;
    position: relative;
    width: 100%;
    border-radius: 0.375rem;
    border-width: 0px;
    background-color: rgba(0,79,78,0.05);
    padding-left: 0.75rem;
    padding-right: 0.75rem;
    padding-top: 1rem;
    padding-bottom: 1rem;
    font-size: 1rem;
    line-height: 1.5rem;
    outline: 2px solid transparent;
    outline-offset: 2px;
  }
.form-group select:focus{
  --tw-border-opacity: 1;
  border-color: rgb(14 109 108 / var(--tw-border-opacity));
}
.form-group:focus-within input{
  padding-top: 25px;
  padding-bottom: 7px;
}
.form-group:focus-within select {
  }
.form-group.form-group--filled label,
  .form-group:focus-within label {
    transform: translate(0, 4px) scale(0.7);
  }
.form-group.form-group--filled input{
  padding-top: 25px;
  padding-bottom: 7px;
}
.form-group input:-webkit-autofill + label,
  .form-group input:-webkit-autofill:hover + label,
  .form-group input:-webkit-autofill:focus + label,
  .form-group input:-webkit-autofill:active + label {
    transform: translate(0, 4px) scale(0.7);
  }
.form-group input:-webkit-autofill,
  .form-group input:-webkit-autofill:hover,
  .form-group input:-webkit-autofill:focus,
  .form-group input:-webkit-autofill:active{
  padding-top: 25px;
  padding-bottom: 7px;
}
.password-visible{
  position: absolute;
  top: 0px;
  bottom: 0px;
  right: 0px;
  display: flex;
  cursor: pointer;
  align-items: center;
  padding-right: 0.75rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-text-opacity: 1;
  color: rgb(14 109 108 / var(--tw-text-opacity));
}
/* ------------ Buttons ------------ */
button,
  .btn{
  display: inline-block;
  border-radius: 10px;
  border-width: 2px;
  --tw-border-opacity: 1;
  border-color: rgb(14 109 108 / var(--tw-border-opacity));
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 9px;
  padding-bottom: 9px;
  text-align: center;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 600;
  line-height: 14px;
  --tw-text-opacity: 1;
  color: rgb(14 109 108 / var(--tw-text-opacity));
}
button:disabled,
  .btn:disabled {
    opacity: 0.6;
  }
.btn--big{
  width: 100%;
  padding: 19px;
}
@media (min-width: 1024px){

  .btn--big{
    padding-left: 40px;
    padding-right: 40px;
  }
}
.btn--dark{
  --tw-bg-opacity: 1;
  background-color: rgb(14 109 108 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.btn--white{
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.btn--gray{
  border-color: rgba(0,79,78,0.2);
}
.btn--shadow{
  --tw-shadow: 0px 2px 6px rgba(0,0,0,0.17), 0px 6px 18px rgba(0,0,0,0.1);
  --tw-shadow-colored: 0px 2px 6px var(--tw-shadow-color), 0px 6px 18px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
{
    /* */
  }
/* ------------ Alerts ------------ */
/* ------------ Typography ------------ */
.fullpage-title{
  position: relative;
  margin-bottom: 30px;
  display: flex;
  height: 36px;
  width: 100%;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(0 79 78 / var(--tw-text-opacity));
}
/* ------------ SignUp ------------ */
.signup-description {
    font-weight: 500;
    margin: 0 0 32px 0;
  }
/* ------------ Password check ------------ */
.password-check li.active {
    color: #3eb76e;
  }
.password-check li.active:before {
    background: #3eb76e;
  }
/* ------------ Datepicker ------------ */
.root {
    background-color: '#0b6463f2' !important;
  }
.css-3eghsz-PrivatePickersYear-button.Mui-selected {
    color: #fff;
    background-color: #004f4e !important;
  }
.css-15fehp8-MuiTypography-root-PrivatePickersMonth-root.Mui-selected {
    color: #fff;
    background-color: #004f4e !important;
  }
.css-1hy66ry-MuiPaper-root-MuiPickersPopper-paper
    .MuiPickersDay-root.Mui-selected {
    background-color: #004f4e !important;
  }
/* ------------ Checkbox ------------ */
.checkbox {
    position: relative;
  }
.checkbox a {
    color: #0e6d6c;
  }
.checkbox input[type='checkbox'] {
    position: absolute;
    left: 0;
    opacity: 0.01;
  }
.checkbox input[type='checkbox'] + label {
    padding-left: 30px;
    display: block;
  }
.checkbox input[type='checkbox'] + label:before {
    content: '';
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
    border: 2px solid rgba(0, 79, 78, 0.4);
    border-radius: 5px;
    cursor: pointer;
    display: block;
    width: 18px;
    height: 18px;
    transition: all 0.2s ease-in-out;
  }
.checkbox input[type='checkbox']:checked + label:before {
    background: #0e6d6c;
  }
.checkbox input[type='checkbox'] + label {
    margin-right: 4px;
  }
.pointer-events-none{
  pointer-events: none;
}
.pointer-events-auto{
  pointer-events: auto;
}
.visible{
  visibility: visible;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.sticky{
  position: sticky;
}
.inset-x-0{
  left: 0px;
  right: 0px;
}
.-bottom-8{
  bottom: -2rem;
}
.-top-8{
  top: -2rem;
}
.bottom-0{
  bottom: 0px;
}
.bottom-4{
  bottom: 1rem;
}
.bottom-5{
  bottom: 1.25rem;
}
.bottom-\\[-20px\\]{
  bottom: -20px;
}
.bottom-\\[0\\%\\]{
  bottom: 0%;
}
.bottom-auto{
  bottom: auto;
}
.left-0{
  left: 0px;
}
.left-1\\/2{
  left: 50%;
}
.left-2{
  left: 0.5rem;
}
.right-0{
  right: 0px;
}
.right-2{
  right: 0.5rem;
}
.right-4{
  right: 1rem;
}
.right-5{
  right: 1.25rem;
}
.right-8{
  right: 2rem;
}
.right-\\[20px\\]{
  right: 20px;
}
.top-0{
  top: 0px;
}
.top-1\\/2{
  top: 50%;
}
.top-2{
  top: 0.5rem;
}
.top-4{
  top: 1rem;
}
.top-5{
  top: 1.25rem;
}
.top-\\[-30px\\]{
  top: -30px;
}
.top-\\[100vh\\]{
  top: 100vh;
}
.top-\\[20px\\]{
  top: 20px;
}
.top-\\[2px\\]{
  top: 2px;
}
.top-\\[50\\%\\]{
  top: 50%;
}
.top-\\[62px\\]{
  top: 62px;
}
.z-10{
  z-index: 10;
}
.z-20{
  z-index: 20;
}
.z-30{
  z-index: 30;
}
.z-40{
  z-index: 40;
}
.z-50{
  z-index: 50;
}
.z-\\[100\\]{
  z-index: 100;
}
.z-\\[101\\]{
  z-index: 101;
}
.m-0{
  margin: 0px;
}
.m-1{
  margin: 0.25rem;
}
.m-auto{
  margin: auto;
}
.mx-1{
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-2{
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-3{
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}
.mx-4{
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-\\[10px\\]{
  margin-left: 10px;
  margin-right: 10px;
}
.mx-\\[20px\\]{
  margin-left: 20px;
  margin-right: 20px;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.my-10{
  margin-top: 2.5rem;
  margin-bottom: 2.5rem;
}
.my-2{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-4{
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-5{
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}
.my-6{
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.my-7{
  margin-top: 1.75rem;
  margin-bottom: 1.75rem;
}
.my-8{
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.my-\\[1\\.5rem\\]{
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.my-\\[12px\\]{
  margin-top: 12px;
  margin-bottom: 12px;
}
.my-\\[16px\\]{
  margin-top: 16px;
  margin-bottom: 16px;
}
.my-\\[20px\\]{
  margin-top: 20px;
  margin-bottom: 20px;
}
.my-\\[24px\\]{
  margin-top: 24px;
  margin-bottom: 24px;
}
.my-\\[28px\\]{
  margin-top: 28px;
  margin-bottom: 28px;
}
.my-\\[2rem\\]{
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.my-\\[30px\\]{
  margin-top: 30px;
  margin-bottom: 30px;
}
.my-\\[32px\\]{
  margin-top: 32px;
  margin-bottom: 32px;
}
.my-\\[41px\\]{
  margin-top: 41px;
  margin-bottom: 41px;
}
.-mt-\\[48px\\]{
  margin-top: -48px;
}
.mb-1{
  margin-bottom: 0.25rem;
}
.mb-16{
  margin-bottom: 4rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-3{
  margin-bottom: 0.75rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-5{
  margin-bottom: 1.25rem;
}
.mb-6{
  margin-bottom: 1.5rem;
}
.mb-9{
  margin-bottom: 2.25rem;
}
.mb-\\[0\\.75rem\\]{
  margin-bottom: 0.75rem;
}
.mb-\\[100px\\]{
  margin-bottom: 100px;
}
.mb-\\[10px\\]{
  margin-bottom: 10px;
}
.mb-\\[12px\\]{
  margin-bottom: 12px;
}
.mb-\\[15px\\]{
  margin-bottom: 15px;
}
.mb-\\[16px\\]{
  margin-bottom: 16px;
}
.mb-\\[18px\\]{
  margin-bottom: 18px;
}
.mb-\\[20px\\]{
  margin-bottom: 20px;
}
.mb-\\[24px\\]{
  margin-bottom: 24px;
}
.mb-\\[25px\\]{
  margin-bottom: 25px;
}
.mb-\\[27px\\]{
  margin-bottom: 27px;
}
.mb-\\[32px\\]{
  margin-bottom: 32px;
}
.mb-\\[34px\\]{
  margin-bottom: 34px;
}
.mb-\\[40px\\]{
  margin-bottom: 40px;
}
.mb-\\[48px\\]{
  margin-bottom: 48px;
}
.mb-\\[4px\\]{
  margin-bottom: 4px;
}
.mb-\\[56px\\]{
  margin-bottom: 56px;
}
.mb-\\[5px\\]{
  margin-bottom: 5px;
}
.mb-\\[97px\\]{
  margin-bottom: 97px;
}
.ml-1{
  margin-left: 0.25rem;
}
.ml-12{
  margin-left: 3rem;
}
.ml-2{
  margin-left: 0.5rem;
}
.ml-3{
  margin-left: 0.75rem;
}
.ml-4{
  margin-left: 1rem;
}
.ml-\\[10px\\]{
  margin-left: 10px;
}
.ml-\\[16px\\]{
  margin-left: 16px;
}
.ml-\\[20px\\]{
  margin-left: 20px;
}
.ml-auto{
  margin-left: auto;
}
.mr-2{
  margin-right: 0.5rem;
}
.mr-4{
  margin-right: 1rem;
}
.mr-7{
  margin-right: 1.75rem;
}
.mr-\\[-30px\\]{
  margin-right: -30px;
}
.mr-\\[18px\\]{
  margin-right: 18px;
}
.mr-\\[20px\\]{
  margin-right: 20px;
}
.mr-\\[4px\\]{
  margin-right: 4px;
}
.mr-\\[8px\\]{
  margin-right: 8px;
}
.mr-auto{
  margin-right: auto;
}
.mt-1{
  margin-top: 0.25rem;
}
.mt-10{
  margin-top: 2.5rem;
}
.mt-12{
  margin-top: 3rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-20{
  margin-top: 5rem;
}
.mt-3{
  margin-top: 0.75rem;
}
.mt-4{
  margin-top: 1rem;
}
.mt-5{
  margin-top: 1.25rem;
}
.mt-6{
  margin-top: 1.5rem;
}
.mt-7{
  margin-top: 1.75rem;
}
.mt-8{
  margin-top: 2rem;
}
.mt-9{
  margin-top: 2.25rem;
}
.mt-\\[-12\\.5\\%\\]{
  margin-top: -12.5%;
}
.mt-\\[-20px\\]{
  margin-top: -20px;
}
.mt-\\[-2px\\]{
  margin-top: -2px;
}
.mt-\\[12px\\]{
  margin-top: 12px;
}
.mt-\\[16px\\]{
  margin-top: 16px;
}
.mt-\\[2\\.25rem\\]{
  margin-top: 2.25rem;
}
.mt-\\[20px\\]{
  margin-top: 20px;
}
.mt-\\[240px\\]{
  margin-top: 240px;
}
.mt-\\[24px\\]{
  margin-top: 24px;
}
.mt-\\[32px\\]{
  margin-top: 32px;
}
.mt-\\[36px\\]{
  margin-top: 36px;
}
.mt-\\[480px\\]{
  margin-top: 480px;
}
.mt-\\[4px\\]{
  margin-top: 4px;
}
.mt-\\[50px\\]{
  margin-top: 50px;
}
.mt-\\[72px\\]{
  margin-top: 72px;
}
.mt-\\[76px\\]{
  margin-top: 76px;
}
.mt-\\[8px\\]{
  margin-top: 8px;
}
.mt-\\[96px\\]{
  margin-top: 96px;
}
.block{
  display: block;
}
.inline-block{
  display: inline-block;
}
.flex{
  display: flex;
}
.grid{
  display: grid;
}
.contents{
  display: contents;
}
.hidden{
  display: none;
}
.h-12{
  height: 3rem;
}
.h-16{
  height: 4rem;
}
.h-2{
  height: 0.5rem;
}
.h-3{
  height: 0.75rem;
}
.h-4{
  height: 1rem;
}
.h-6{
  height: 1.5rem;
}
.h-7{
  height: 1.75rem;
}
.h-8{
  height: 2rem;
}
.h-\\[1\\.375rem\\]{
  height: 1.375rem;
}
.h-\\[10\\%\\]{
  height: 10%;
}
.h-\\[100\\%\\]{
  height: 100%;
}
.h-\\[100px\\]{
  height: 100px;
}
.h-\\[100vh\\]{
  height: 100vh;
}
.h-\\[108px\\]{
  height: 108px;
}
.h-\\[10px\\]{
  height: 10px;
}
.h-\\[112px\\]{
  height: 112px;
}
.h-\\[11px\\]{
  height: 11px;
}
.h-\\[120px\\]{
  height: 120px;
}
.h-\\[12px\\]{
  height: 12px;
}
.h-\\[130px\\]{
  height: 130px;
}
.h-\\[13px\\]{
  height: 13px;
}
.h-\\[140px\\]{
  height: 140px;
}
.h-\\[16px\\]{
  height: 16px;
}
.h-\\[175px\\]{
  height: 175px;
}
.h-\\[18px\\]{
  height: 18px;
}
.h-\\[19px\\]{
  height: 19px;
}
.h-\\[20\\%\\]{
  height: 20%;
}
.h-\\[200px\\]{
  height: 200px;
}
.h-\\[206px\\]{
  height: 206px;
}
.h-\\[20px\\]{
  height: 20px;
}
.h-\\[220px\\]{
  height: 220px;
}
.h-\\[22px\\]{
  height: 22px;
}
.h-\\[240px\\]{
  height: 240px;
}
.h-\\[24px\\]{
  height: 24px;
}
.h-\\[25\\%\\]{
  height: 25%;
}
.h-\\[25px\\]{
  height: 25px;
}
.h-\\[28px\\]{
  height: 28px;
}
.h-\\[30\\%\\]{
  height: 30%;
}
.h-\\[300px\\]{
  height: 300px;
}
.h-\\[30px\\]{
  height: 30px;
}
.h-\\[320px\\]{
  height: 320px;
}
.h-\\[32px\\]{
  height: 32px;
}
.h-\\[35px\\]{
  height: 35px;
}
.h-\\[360px\\]{
  height: 360px;
}
.h-\\[36px\\]{
  height: 36px;
}
.h-\\[38px\\]{
  height: 38px;
}
.h-\\[40\\%\\]{
  height: 40%;
}
.h-\\[40px\\]{
  height: 40px;
}
.h-\\[430px\\]{
  height: 430px;
}
.h-\\[45\\%\\]{
  height: 45%;
}
.h-\\[48px\\]{
  height: 48px;
}
.h-\\[5\\%\\]{
  height: 5%;
}
.h-\\[50px\\]{
  height: 50px;
}
.h-\\[60px\\]{
  height: 60px;
}
.h-\\[700px\\]{
  height: 700px;
}
.h-\\[70px\\]{
  height: 70px;
}
.h-\\[72px\\]{
  height: 72px;
}
.h-\\[75px\\]{
  height: 75px;
}
.h-\\[80px\\]{
  height: 80px;
}
.h-\\[8px\\]{
  height: 8px;
}
.h-\\[90\\%\\]{
  height: 90%;
}
.h-\\[90px\\]{
  height: 90px;
}
.h-auto{
  height: auto;
}
.h-full{
  height: 100%;
}
.h-screen{
  height: 100vh;
}
.max-h-0{
  max-height: 0px;
}
.max-h-\\[240px\\]{
  max-height: 240px;
}
.max-h-\\[520px\\]{
  max-height: 520px;
}
.max-h-\\[630px\\]{
  max-height: 630px;
}
.max-h-\\[86px\\]{
  max-height: 86px;
}
.max-h-\\[90\\%\\]{
  max-height: 90%;
}
.max-h-\\[9999px\\]{
  max-height: 9999px;
}
.min-h-64{
  min-height: 16rem;
}
.min-h-\\[100\\%\\]{
  min-height: 100%;
}
.min-h-\\[100vh\\]{
  min-height: 100vh;
}
.min-h-\\[120px\\]{
  min-height: 120px;
}
.min-h-\\[200px\\]{
  min-height: 200px;
}
.min-h-\\[300px\\]{
  min-height: 300px;
}
.min-h-\\[380px\\]{
  min-height: 380px;
}
.min-h-\\[40px\\]{
  min-height: 40px;
}
.min-h-\\[496px\\]{
  min-height: 496px;
}
.min-h-\\[597px\\]{
  min-height: 597px;
}
.min-h-full{
  min-height: 100%;
}
.min-h-screen{
  min-height: 100vh;
}
.w-12{
  width: 3rem;
}
.w-3{
  width: 0.75rem;
}
.w-4{
  width: 1rem;
}
.w-40{
  width: 10rem;
}
.w-6{
  width: 1.5rem;
}
.w-8\\/12{
  width: 66.666667%;
}
.w-\\[100\\%\\]{
  width: 100%;
}
.w-\\[100px\\]{
  width: 100px;
}
.w-\\[109px\\]{
  width: 109px;
}
.w-\\[10px\\]{
  width: 10px;
}
.w-\\[11px\\]{
  width: 11px;
}
.w-\\[120\\%\\]{
  width: 120%;
}
.w-\\[125px\\]{
  width: 125px;
}
.w-\\[12px\\]{
  width: 12px;
}
.w-\\[130px\\]{
  width: 130px;
}
.w-\\[13px\\]{
  width: 13px;
}
.w-\\[150px\\]{
  width: 150px;
}
.w-\\[16px\\]{
  width: 16px;
}
.w-\\[180px\\]{
  width: 180px;
}
.w-\\[18px\\]{
  width: 18px;
}
.w-\\[20\\%\\]{
  width: 20%;
}
.w-\\[200px\\]{
  width: 200px;
}
.w-\\[20px\\]{
  width: 20px;
}
.w-\\[22px\\]{
  width: 22px;
}
.w-\\[230px\\]{
  width: 230px;
}
.w-\\[24px\\]{
  width: 24px;
}
.w-\\[28px\\]{
  width: 28px;
}
.w-\\[2px\\]{
  width: 2px;
}
.w-\\[30\\%\\]{
  width: 30%;
}
.w-\\[30px\\]{
  width: 30px;
}
.w-\\[310px\\]{
  width: 310px;
}
.w-\\[336px\\]{
  width: 336px;
}
.w-\\[38vh\\]{
  width: 38vh;
}
.w-\\[40\\%\\]{
  width: 40%;
}
.w-\\[400px\\]{
  width: 400px;
}
.w-\\[40px\\]{
  width: 40px;
}
.w-\\[44px\\]{
  width: 44px;
}
.w-\\[45\\%\\]{
  width: 45%;
}
.w-\\[46px\\]{
  width: 46px;
}
.w-\\[48px\\]{
  width: 48px;
}
.w-\\[49\\%\\]{
  width: 49%;
}
.w-\\[50\\%\\]{
  width: 50%;
}
.w-\\[60\\%\\]{
  width: 60%;
}
.w-\\[600\\%\\]{
  width: 600%;
}
.w-\\[60px\\]{
  width: 60px;
}
.w-\\[64px\\]{
  width: 64px;
}
.w-\\[68px\\]{
  width: 68px;
}
.w-\\[70\\%\\]{
  width: 70%;
}
.w-\\[80\\%\\]{
  width: 80%;
}
.w-\\[80px\\]{
  width: 80px;
}
.w-\\[85\\%\\]{
  width: 85%;
}
.w-\\[88\\%\\]{
  width: 88%;
}
.w-\\[89px\\]{
  width: 89px;
}
.w-\\[90\\%\\]{
  width: 90%;
}
.w-\\[90px\\]{
  width: 90px;
}
.w-\\[92\\%\\]{
  width: 92%;
}
.w-\\[95\\%\\]{
  width: 95%;
}
.w-\\[96px\\]{
  width: 96px;
}
.w-\\[97px\\]{
  width: 97px;
}
.w-\\[98\\%\\]{
  width: 98%;
}
.w-\\[99\\%\\]{
  width: 99%;
}
.w-\\[calc\\(100\\%_\\+_1\\.3px\\)\\]{
  width: calc(100% + 1.3px);
}
.w-full{
  width: 100%;
}
.w-screen{
  width: 100vw;
}
.min-w-\\[150px\\]{
  min-width: 150px;
}
.max-w-\\[970px\\]{
  max-width: 970px;
}
.max-w-full{
  max-width: 100%;
}
.flex-1{
  flex: 1 1;
}
.flex-none{
  flex: none;
}
.grow{
  flex-grow: 1;
}
.basis-1\\/2{
  flex-basis: 50%;
}
.basis-1\\/5{
  flex-basis: 20%;
}
.basis-3\\/4{
  flex-basis: 75%;
}
.basis-4\\/5{
  flex-basis: 80%;
}
.-translate-x-1\\/2{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-\\[10px\\]{
  --tw-translate-x: -10px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-\\[7px\\]{
  --tw-translate-x: -7px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-full{
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-16{
  --tw-translate-y: -4rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0\\.5{
  --tw-translate-x: 0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-0{
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-24{
  --tw-translate-y: 6rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-\\[-50\\%\\]{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-90{
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-y-\\[-1\\]{
  --tw-scale-y: -1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes pulse{

  50%{
    opacity: .5;
  }
}
.animate-pulse{
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
.cursor-not-allowed{
  cursor: not-allowed;
}
.cursor-pointer{
  cursor: pointer;
}
.resize{
  resize: both;
}
.list-outside{
  list-style-position: outside;
}
.list-disc{
  list-style-type: disc;
}
.list-none{
  list-style-type: none;
}
.appearance-none{
  appearance: none;
}
.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3{
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.flex-row{
  flex-direction: row;
}
.flex-col{
  flex-direction: column;
}
.items-start{
  align-items: flex-start;
}
.items-end{
  align-items: flex-end;
}
.items-center{
  align-items: center;
}
.justify-end{
  justify-content: flex-end;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.justify-around{
  justify-content: space-around;
}
.justify-evenly{
  justify-content: space-evenly;
}
.gap-1{
  gap: 0.25rem;
}
.gap-10{
  gap: 2.5rem;
}
.gap-12{
  gap: 3rem;
}
.gap-4{
  gap: 1rem;
}
.gap-5{
  gap: 1.25rem;
}
.gap-6{
  gap: 1.5rem;
}
.space-x-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-12 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(3rem * var(--tw-space-x-reverse));
  margin-left: calc(3rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-\\[10px\\] > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(10px * var(--tw-space-x-reverse));
  margin-left: calc(10px * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-\\[18px\\] > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(18px * var(--tw-space-x-reverse));
  margin-left: calc(18px * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-\\[8px\\] > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(8px * var(--tw-space-x-reverse));
  margin-left: calc(8px * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-12 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(3rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(3rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.self-center{
  align-self: center;
}
.overflow-hidden{
  overflow: hidden;
}
.overflow-y-auto{
  overflow-y: auto;
}
.overflow-x-hidden{
  overflow-x: hidden;
}
.overflow-y-scroll{
  overflow-y: scroll;
}
.break-words{
  overflow-wrap: break-word;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-2xl{
  border-radius: 1rem;
}
.rounded-\\[10px\\]{
  border-radius: 10px;
}
.rounded-\\[15px\\]{
  border-radius: 15px;
}
.rounded-\\[20px\\]{
  border-radius: 20px;
}
.rounded-\\[25px\\]{
  border-radius: 25px;
}
.rounded-\\[28px\\]{
  border-radius: 28px;
}
.rounded-\\[45\\%\\]{
  border-radius: 45%;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-lg{
  border-radius: 0.5rem;
}
.rounded-md{
  border-radius: 0.375rem;
}
.rounded-xl{
  border-radius: 0.75rem;
}
.rounded-b-lg{
  border-bottom-right-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.rounded-r-xl{
  border-top-right-radius: 0.75rem;
  border-bottom-right-radius: 0.75rem;
}
.rounded-t-\\[10px\\]{
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.rounded-t-\\[15px\\]{
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
}
.rounded-t-lg{
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}
.border{
  border-width: 1px;
}
.border-0{
  border-width: 0px;
}
.border-2{
  border-width: 2px;
}
.border-4{
  border-width: 4px;
}
.border-x-8{
  border-left-width: 8px;
  border-right-width: 8px;
}
.border-y-\\[25px\\]{
  border-top-width: 25px;
  border-bottom-width: 25px;
}
.border-b{
  border-bottom-width: 1px;
}
.border-b-2{
  border-bottom-width: 2px;
}
.border-b-4{
  border-bottom-width: 4px;
}
.border-b-\\[2\\.5px\\]{
  border-bottom-width: 2.5px;
}
.border-r-2{
  border-right-width: 2px;
}
.border-r-\\[2\\.5px\\]{
  border-right-width: 2.5px;
}
.border-t-2{
  border-top-width: 2px;
}
.border-t-\\[2\\.5px\\]{
  border-top-width: 2.5px;
}
.border-dashed{
  border-style: dashed;
}
.border-none{
  border-style: none;
}
.border-\\[\\#004F4E\\]{
  --tw-border-opacity: 1;
  border-color: rgb(0 79 78 / var(--tw-border-opacity));
}
.border-\\[\\#021212\\]{
  --tw-border-opacity: 1;
  border-color: rgb(2 18 18 / var(--tw-border-opacity));
}
.border-\\[\\#0491D1\\]{
  --tw-border-opacity: 1;
  border-color: rgb(4 145 209 / var(--tw-border-opacity));
}
.border-\\[\\#3EB76E\\]{
  --tw-border-opacity: 1;
  border-color: rgb(62 183 110 / var(--tw-border-opacity));
}
.border-\\[\\#5FC0BE\\]{
  --tw-border-opacity: 1;
  border-color: rgb(95 192 190 / var(--tw-border-opacity));
}
.border-\\[\\#C4E8E8\\]{
  --tw-border-opacity: 1;
  border-color: rgb(196 232 232 / var(--tw-border-opacity));
}
.border-\\[\\#E3F2F2\\]{
  --tw-border-opacity: 1;
  border-color: rgb(227 242 242 / var(--tw-border-opacity));
}
.border-\\[\\#EFF9F9\\]{
  --tw-border-opacity: 1;
  border-color: rgb(239 249 249 / var(--tw-border-opacity));
}
.border-\\[\\#FF7A00\\]{
  --tw-border-opacity: 1;
  border-color: rgb(255 122 0 / var(--tw-border-opacity));
}
.border-\\[rgba\\(0\\2c 79\\2c 78\\2c 0\\.2\\)\\]{
  border-color: rgba(0,79,78,0.2);
}
.border-blue-500{
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity));
}
.border-green-400{
  --tw-border-opacity: 1;
  border-color: rgb(74 222 128 / var(--tw-border-opacity));
}
.border-inputBackground{
  --tw-border-opacity: 1;
  border-color: rgb(242 246 246 / var(--tw-border-opacity));
}
.border-primary{
  --tw-border-opacity: 1;
  border-color: rgb(14 109 108 / var(--tw-border-opacity));
}
.border-primaryDark{
  --tw-border-opacity: 1;
  border-color: rgb(0 79 78 / var(--tw-border-opacity));
}
.border-primaryLight{
  --tw-border-opacity: 1;
  border-color: rgb(127 229 228 / var(--tw-border-opacity));
}
.border-red-500{
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity));
}
.border-slate-200{
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity));
}
.border-transparent{
  border-color: transparent;
}
.border-white{
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.border-yellow-400{
  --tw-border-opacity: 1;
  border-color: rgb(250 204 21 / var(--tw-border-opacity));
}
.border-opacity-25{
  --tw-border-opacity: 0.25;
}
.border-opacity-75{
  --tw-border-opacity: 0.75;
}
.bg-\\[\\#004F4E\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(0 79 78 / var(--tw-bg-opacity));
}
.bg-\\[\\#0091cf\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(0 145 207 / var(--tw-bg-opacity));
}
.bg-\\[\\#00B2FF\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(0 178 255 / var(--tw-bg-opacity));
}
.bg-\\[\\#021212BF\\]{
  background-color: #021212BF;
}
.bg-\\[\\#021212\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(2 18 18 / var(--tw-bg-opacity));
}
.bg-\\[\\#27894E\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(39 137 78 / var(--tw-bg-opacity));
}
.bg-\\[\\#3EB76E\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(62 183 110 / var(--tw-bg-opacity));
}
.bg-\\[\\#64748b\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(100 116 139 / var(--tw-bg-opacity));
}
.bg-\\[\\#7FE5E480\\]{
  background-color: #7FE5E480;
}
.bg-\\[\\#7FE5E4\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(127 229 228 / var(--tw-bg-opacity));
}
.bg-\\[\\#90F2B8\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(144 242 184 / var(--tw-bg-opacity));
}
.bg-\\[\\#C4E8E8\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(196 232 232 / var(--tw-bg-opacity));
}
.bg-\\[\\#E2FFFF\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(226 255 255 / var(--tw-bg-opacity));
}
.bg-\\[\\#E3F2F2\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(227 242 242 / var(--tw-bg-opacity));
}
.bg-\\[\\#E3F2F3\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(227 242 243 / var(--tw-bg-opacity));
}
.bg-\\[\\#E48310\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(228 131 16 / var(--tw-bg-opacity));
}
.bg-\\[\\#EBB700\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(235 183 0 / var(--tw-bg-opacity));
}
.bg-\\[\\#EFF9F9\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(239 249 249 / var(--tw-bg-opacity));
}
.bg-\\[\\#F0F4FF\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(240 244 255 / var(--tw-bg-opacity));
}
.bg-\\[\\#F2F6F6\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(242 246 246 / var(--tw-bg-opacity));
}
.bg-\\[\\#F3FCFC\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(243 252 252 / var(--tw-bg-opacity));
}
.bg-\\[\\#FF3D00\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 61 0 / var(--tw-bg-opacity));
}
.bg-\\[\\#FFE5DD\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 229 221 / var(--tw-bg-opacity));
}
.bg-\\[\\#FFEDAF\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 237 175 / var(--tw-bg-opacity));
}
.bg-\\[\\#e9e9e9\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(233 233 233 / var(--tw-bg-opacity));
}
.bg-accent{
  --tw-bg-opacity: 1;
  background-color: rgb(127 229 228 / var(--tw-bg-opacity));
}
.bg-accentLight{
  --tw-bg-opacity: 1;
  background-color: rgb(205 252 251 / var(--tw-bg-opacity));
}
.bg-black{
  --tw-bg-opacity: 1;
  background-color: rgb(2 18 18 / var(--tw-bg-opacity));
}
.bg-black\\/70{
  background-color: rgb(2 18 18 / 0.7);
}
.bg-blue-600{
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity));
}
.bg-green-100\\/50{
  background-color: rgb(220 252 231 / 0.5);
}
.bg-green-500{
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity));
}
.bg-orange-100\\/50{
  background-color: rgb(255 237 213 / 0.5);
}
.bg-orange-200{
  --tw-bg-opacity: 1;
  background-color: rgb(254 215 170 / var(--tw-bg-opacity));
}
.bg-orange-500{
  --tw-bg-opacity: 1;
  background-color: rgb(249 115 22 / var(--tw-bg-opacity));
}
.bg-primary{
  --tw-bg-opacity: 1;
  background-color: rgb(14 109 108 / var(--tw-bg-opacity));
}
.bg-primaryDark{
  --tw-bg-opacity: 1;
  background-color: rgb(0 79 78 / var(--tw-bg-opacity));
}
.bg-primaryLight{
  --tw-bg-opacity: 1;
  background-color: rgb(127 229 228 / var(--tw-bg-opacity));
}
.bg-red-500{
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity));
}
.bg-red-600{
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity));
}
.bg-slate-100{
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity));
}
.bg-slate-200{
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity));
}
.bg-transparent{
  background-color: transparent;
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-yellow-500{
  --tw-bg-opacity: 1;
  background-color: rgb(234 179 8 / var(--tw-bg-opacity));
}
.bg-gradient-to-r{
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.from-indigo-500{
  --tw-gradient-from: #6366f1 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(99 102 241 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-purple-500{
  --tw-gradient-to: rgb(168 85 247 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #a855f7 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-pink-500{
  --tw-gradient-to: #ec4899 var(--tw-gradient-to-position);
}
.bg-cover{
  background-size: cover;
}
.bg-clip-padding{
  background-clip: padding-box;
}
.bg-center{
  background-position: center;
}
.bg-top{
  background-position: top;
}
.bg-no-repeat{
  background-repeat: no-repeat;
}
.fill-\\[\\#7FE5E4\\]{
  fill: #7FE5E4;
}
.fill-current{
  fill: currentColor;
}
.fill-white{
  fill: #fff;
}
.object-contain{
  object-fit: contain;
}
.object-cover{
  object-fit: cover;
}
.object-top{
  object-position: top;
}
.p-0{
  padding: 0px;
}
.p-1{
  padding: 0.25rem;
}
.p-10{
  padding: 2.5rem;
}
.p-12{
  padding: 3rem;
}
.p-3{
  padding: 0.75rem;
}
.p-4{
  padding: 1rem;
}
.p-5{
  padding: 1.25rem;
}
.p-6{
  padding: 1.5rem;
}
.p-7{
  padding: 1.75rem;
}
.p-\\[12px\\]{
  padding: 12px;
}
.p-\\[16px\\]{
  padding: 16px;
}
.p-\\[20px\\]{
  padding: 20px;
}
.p-\\[24px\\]{
  padding: 24px;
}
.p-\\[4px\\]{
  padding: 4px;
}
.p-\\[9px\\]{
  padding: 9px;
}
.px-1{
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-10{
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.px-14{
  padding-left: 3.5rem;
  padding-right: 3.5rem;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-7{
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.px-8{
  padding-left: 2rem;
  padding-right: 2rem;
}
.px-\\[10px\\]{
  padding-left: 10px;
  padding-right: 10px;
}
.px-\\[14px\\]{
  padding-left: 14px;
  padding-right: 14px;
}
.px-\\[15px\\]{
  padding-left: 15px;
  padding-right: 15px;
}
.px-\\[16px\\]{
  padding-left: 16px;
  padding-right: 16px;
}
.px-\\[18px\\]{
  padding-left: 18px;
  padding-right: 18px;
}
.px-\\[1rem\\]{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-\\[20px\\]{
  padding-left: 20px;
  padding-right: 20px;
}
.px-\\[24px\\]{
  padding-left: 24px;
  padding-right: 24px;
}
.px-\\[30px\\]{
  padding-left: 30px;
  padding-right: 30px;
}
.px-\\[32px\\]{
  padding-left: 32px;
  padding-right: 32px;
}
.px-\\[36px\\]{
  padding-left: 36px;
  padding-right: 36px;
}
.px-\\[4px\\]{
  padding-left: 4px;
  padding-right: 4px;
}
.px-\\[8px\\]{
  padding-left: 8px;
  padding-right: 8px;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10{
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-12{
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5{
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-7{
  padding-top: 1.75rem;
  padding-bottom: 1.75rem;
}
.py-8{
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.py-\\[0\\.75rem\\]{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-\\[1\\.5rem\\]{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-\\[10px\\]{
  padding-top: 10px;
  padding-bottom: 10px;
}
.py-\\[11px\\]{
  padding-top: 11px;
  padding-bottom: 11px;
}
.py-\\[12px\\]{
  padding-top: 12px;
  padding-bottom: 12px;
}
.py-\\[14px\\]{
  padding-top: 14px;
  padding-bottom: 14px;
}
.py-\\[15px\\]{
  padding-top: 15px;
  padding-bottom: 15px;
}
.py-\\[16px\\]{
  padding-top: 16px;
  padding-bottom: 16px;
}
.py-\\[17px\\]{
  padding-top: 17px;
  padding-bottom: 17px;
}
.py-\\[18px\\]{
  padding-top: 18px;
  padding-bottom: 18px;
}
.py-\\[19px\\]{
  padding-top: 19px;
  padding-bottom: 19px;
}
.py-\\[20px\\]{
  padding-top: 20px;
  padding-bottom: 20px;
}
.py-\\[21px\\]{
  padding-top: 21px;
  padding-bottom: 21px;
}
.py-\\[24px\\]{
  padding-top: 24px;
  padding-bottom: 24px;
}
.py-\\[32px\\]{
  padding-top: 32px;
  padding-bottom: 32px;
}
.py-\\[35px\\]{
  padding-top: 35px;
  padding-bottom: 35px;
}
.py-\\[36px\\]{
  padding-top: 36px;
  padding-bottom: 36px;
}
.py-\\[38px\\]{
  padding-top: 38px;
  padding-bottom: 38px;
}
.py-\\[3px\\]{
  padding-top: 3px;
  padding-bottom: 3px;
}
.py-\\[48px\\]{
  padding-top: 48px;
  padding-bottom: 48px;
}
.py-\\[4px\\]{
  padding-top: 4px;
  padding-bottom: 4px;
}
.py-\\[60px\\]{
  padding-top: 60px;
  padding-bottom: 60px;
}
.py-\\[8px\\]{
  padding-top: 8px;
  padding-bottom: 8px;
}
.py-\\[96px\\]{
  padding-top: 96px;
  padding-bottom: 96px;
}
.py-\\[9px\\]{
  padding-top: 9px;
  padding-bottom: 9px;
}
.pb-1{
  padding-bottom: 0.25rem;
}
.pb-10{
  padding-bottom: 2.5rem;
}
.pb-16{
  padding-bottom: 4rem;
}
.pb-2{
  padding-bottom: 0.5rem;
}
.pb-3{
  padding-bottom: 0.75rem;
}
.pb-4{
  padding-bottom: 1rem;
}
.pb-5{
  padding-bottom: 1.25rem;
}
.pb-\\[100px\\]{
  padding-bottom: 100px;
}
.pb-\\[10px\\]{
  padding-bottom: 10px;
}
.pb-\\[12px\\]{
  padding-bottom: 12px;
}
.pb-\\[24px\\]{
  padding-bottom: 24px;
}
.pb-\\[2rem\\]{
  padding-bottom: 2rem;
}
.pb-\\[32px\\]{
  padding-bottom: 32px;
}
.pb-\\[40px\\]{
  padding-bottom: 40px;
}
.pb-\\[60px\\]{
  padding-bottom: 60px;
}
.pb-\\[68px\\]{
  padding-bottom: 68px;
}
.pb-\\[8px\\]{
  padding-bottom: 8px;
}
.pl-1{
  padding-left: 0.25rem;
}
.pl-3{
  padding-left: 0.75rem;
}
.pl-4{
  padding-left: 1rem;
}
.pl-5{
  padding-left: 1.25rem;
}
.pl-6{
  padding-left: 1.5rem;
}
.pl-\\[20px\\]{
  padding-left: 20px;
}
.pl-\\[5px\\]{
  padding-left: 5px;
}
.pr-0{
  padding-right: 0px;
}
.pr-2{
  padding-right: 0.5rem;
}
.pr-5{
  padding-right: 1.25rem;
}
.pr-\\[20px\\]{
  padding-right: 20px;
}
.pr-\\[5px\\]{
  padding-right: 5px;
}
.pr-\\[8\\%\\]{
  padding-right: 8%;
}
.pr-\\[8px\\]{
  padding-right: 8px;
}
.pt-12{
  padding-top: 3rem;
}
.pt-3{
  padding-top: 0.75rem;
}
.pt-4{
  padding-top: 1rem;
}
.pt-5{
  padding-top: 1.25rem;
}
.pt-6{
  padding-top: 1.5rem;
}
.pt-\\[15px\\]{
  padding-top: 15px;
}
.pt-\\[17px\\]{
  padding-top: 17px;
}
.pt-\\[24px\\]{
  padding-top: 24px;
}
.pt-\\[2rem\\]{
  padding-top: 2rem;
}
.pt-\\[32px\\]{
  padding-top: 32px;
}
.pt-\\[36px\\]{
  padding-top: 36px;
}
.pt-\\[48px\\]{
  padding-top: 48px;
}
.pt-\\[4px\\]{
  padding-top: 4px;
}
.pt-\\[60px\\]{
  padding-top: 60px;
}
.pt-\\[80px\\]{
  padding-top: 80px;
}
.pt-\\[84px\\]{
  padding-top: 84px;
}
.pt-\\[87px\\]{
  padding-top: 87px;
}
.text-center{
  text-align: center;
}
.text-3xl{
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-\\[0\\.6875rem\\]{
  font-size: 0.6875rem;
}
.text-\\[1\\.125rem\\]{
  font-size: 1.125rem;
}
.text-\\[1\\.5rem\\]{
  font-size: 1.5rem;
}
.text-\\[1\\.875rem\\]{
  font-size: 1.875rem;
}
.text-\\[11px\\]{
  font-size: 11px;
}
.text-\\[12px\\]{
  font-size: 12px;
}
.text-\\[13px\\]{
  font-size: 13px;
}
.text-\\[14px\\]{
  font-size: 14px;
}
.text-\\[15px\\]{
  font-size: 15px;
}
.text-\\[16px\\]{
  font-size: 16px;
}
.text-\\[17px\\]{
  font-size: 17px;
}
.text-\\[18px\\]{
  font-size: 18px;
}
.text-\\[1rem\\]{
  font-size: 1rem;
}
.text-\\[2\\.25rem\\]{
  font-size: 2.25rem;
}
.text-\\[20px\\]{
  font-size: 20px;
}
.text-\\[22px\\]{
  font-size: 22px;
}
.text-\\[23px\\]{
  font-size: 23px;
}
.text-\\[24px\\]{
  font-size: 24px;
}
.text-\\[25px\\]{
  font-size: 25px;
}
.text-\\[27px\\]{
  font-size: 27px;
}
.text-\\[2rem\\]{
  font-size: 2rem;
}
.text-\\[30px\\]{
  font-size: 30px;
}
.text-\\[32px\\]{
  font-size: 32px;
}
.text-\\[36px\\]{
  font-size: 36px;
}
.text-\\[48px\\]{
  font-size: 48px;
}
.text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-\\[400\\]{
  font-weight: 400;
}
.font-bold{
  font-weight: 700;
}
.font-extrabold{
  font-weight: 800;
}
.font-normal{
  font-weight: 400;
}
.font-semibold{
  font-weight: 600;
}
.font-thin{
  font-weight: 100;
}
.uppercase{
  text-transform: uppercase;
}
.capitalize{
  text-transform: capitalize;
}
.leading-7{
  line-height: 1.75rem;
}
.leading-8{
  line-height: 2rem;
}
.leading-9{
  line-height: 2.25rem;
}
.leading-\\[0px\\]{
  line-height: 0px;
}
.leading-\\[1\\.03125rem\\]{
  line-height: 1.03125rem;
}
.leading-\\[1\\.79875rem\\]{
  line-height: 1.79875rem;
}
.leading-\\[120\\%\\]{
  line-height: 120%;
}
.leading-\\[120\\.93\\%\\]{
  line-height: 120.93%;
}
.leading-\\[12px\\]{
  line-height: 12px;
}
.leading-\\[13\\.2px\\]{
  line-height: 13.2px;
}
.leading-\\[13\\.76\\%\\]{
  line-height: 13.76%;
}
.leading-\\[13\\.76px\\]{
  line-height: 13.76px;
}
.leading-\\[13px\\]{
  line-height: 13px;
}
.leading-\\[15\\.6px\\]{
  line-height: 15.6px;
}
.leading-\\[150\\%\\]{
  line-height: 150%;
}
.leading-\\[16\\.8px\\]{
  line-height: 16.8px;
}
.leading-\\[16px\\]{
  line-height: 16px;
}
.leading-\\[17\\.78px\\]{
  line-height: 17.78px;
}
.leading-\\[18px\\]{
  line-height: 18px;
}
.leading-\\[19\\.2px\\]{
  line-height: 19.2px;
}
.leading-\\[19\\.83px\\]{
  line-height: 19.83px;
}
.leading-\\[20px\\]{
  line-height: 20px;
}
.leading-\\[21\\.6px\\]{
  line-height: 21.6px;
}
.leading-\\[21px\\]{
  line-height: 21px;
}
.leading-\\[22\\.31px\\]{
  line-height: 22.31px;
}
.leading-\\[22px\\]{
  line-height: 22px;
}
.leading-\\[24px\\]{
  line-height: 24px;
}
.leading-\\[28\\.8px\\]{
  line-height: 28.8px;
}
.leading-\\[29px\\]{
  line-height: 29px;
}
.leading-\\[32\\.37px\\]{
  line-height: 32.37px;
}
.leading-\\[32px\\]{
  line-height: 32px;
}
.leading-\\[38\\.4px\\]{
  line-height: 38.4px;
}
.leading-\\[43\\.2px\\]{
  line-height: 43.2px;
}
.leading-\\[43px\\]{
  line-height: 43px;
}
.leading-\\[48px\\]{
  line-height: 48px;
}
.leading-\\[89\\.93\\%\\]{
  line-height: 89.93%;
}
.leading-relaxed{
  line-height: 1.625;
}
.leading-tight{
  line-height: 1.25;
}
.tracking-\\[0\\.04em\\]{
  letter-spacing: 0.04em;
}
.tracking-wide{
  letter-spacing: 0.025em;
}
.tracking-wider{
  letter-spacing: 0.05em;
}
.tracking-widest{
  letter-spacing: 0.1em;
}
.text-\\[\\#004F4E\\]{
  --tw-text-opacity: 1;
  color: rgb(0 79 78 / var(--tw-text-opacity));
}
.text-\\[\\#021212\\]{
  --tw-text-opacity: 1;
  color: rgb(2 18 18 / var(--tw-text-opacity));
}
.text-\\[\\#0491D1\\]{
  --tw-text-opacity: 1;
  color: rgb(4 145 209 / var(--tw-text-opacity));
}
.text-\\[\\#0E6D6C\\]{
  --tw-text-opacity: 1;
  color: rgb(14 109 108 / var(--tw-text-opacity));
}
.text-\\[\\#1F623A\\]{
  --tw-text-opacity: 1;
  color: rgb(31 98 58 / var(--tw-text-opacity));
}
.text-\\[\\#27894E\\]{
  --tw-text-opacity: 1;
  color: rgb(39 137 78 / var(--tw-text-opacity));
}
.text-\\[\\#3EB76E\\]{
  --tw-text-opacity: 1;
  color: rgb(62 183 110 / var(--tw-text-opacity));
}
.text-\\[\\#527473\\]{
  --tw-text-opacity: 1;
  color: rgb(82 116 115 / var(--tw-text-opacity));
}
.text-\\[\\#676767\\]{
  --tw-text-opacity: 1;
  color: rgb(103 103 103 / var(--tw-text-opacity));
}
.text-\\[\\#727272\\]{
  --tw-text-opacity: 1;
  color: rgb(114 114 114 / var(--tw-text-opacity));
}
.text-\\[\\#7FE5E4\\]{
  --tw-text-opacity: 1;
  color: rgb(127 229 228 / var(--tw-text-opacity));
}
.text-\\[\\#835805\\]{
  --tw-text-opacity: 1;
  color: rgb(131 88 5 / var(--tw-text-opacity));
}
.text-\\[\\#87AEAE\\]{
  --tw-text-opacity: 1;
  color: rgb(135 174 174 / var(--tw-text-opacity));
}
.text-\\[\\#8A8A8A\\]{
  --tw-text-opacity: 1;
  color: rgb(138 138 138 / var(--tw-text-opacity));
}
.text-\\[\\#8B210085\\]{
  color: #8B210085;
}
.text-\\[\\#969696\\]{
  --tw-text-opacity: 1;
  color: rgb(150 150 150 / var(--tw-text-opacity));
}
.text-\\[\\#A5A5A5\\]{
  --tw-text-opacity: 1;
  color: rgb(165 165 165 / var(--tw-text-opacity));
}
.text-\\[\\#EBB700\\]{
  --tw-text-opacity: 1;
  color: rgb(235 183 0 / var(--tw-text-opacity));
}
.text-\\[\\#FF3D00\\]{
  --tw-text-opacity: 1;
  color: rgb(255 61 0 / var(--tw-text-opacity));
}
.text-\\[\\#FF7A00\\]{
  --tw-text-opacity: 1;
  color: rgb(255 122 0 / var(--tw-text-opacity));
}
.text-black{
  --tw-text-opacity: 1;
  color: rgb(2 18 18 / var(--tw-text-opacity));
}
.text-gray-500{
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}
.text-gray-700{
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity));
}
.text-primary{
  --tw-text-opacity: 1;
  color: rgb(14 109 108 / var(--tw-text-opacity));
}
.text-primaryDark{
  --tw-text-opacity: 1;
  color: rgb(0 79 78 / var(--tw-text-opacity));
}
.text-primaryLight{
  --tw-text-opacity: 1;
  color: rgb(127 229 228 / var(--tw-text-opacity));
}
.text-red-500{
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity));
}
.text-red-600{
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity));
}
.text-red-700{
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity));
}
.text-textGreen{
  --tw-text-opacity: 1;
  color: rgb(0 79 78 / var(--tw-text-opacity));
}
.text-warning{
  --tw-text-opacity: 1;
  color: rgb(255 122 0 / var(--tw-text-opacity));
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.underline{
  text-decoration-line: underline;
}
.underline-offset-4{
  text-underline-offset: 4px;
}
.accent-primary{
  accent-color: #0E6D6C;
}
.opacity-0{
  opacity: 0;
}
.opacity-100{
  opacity: 1;
}
.opacity-30{
  opacity: 0.3;
}
.opacity-40{
  opacity: 0.4;
}
.opacity-60{
  opacity: 0.6;
}
.opacity-75{
  opacity: 0.75;
}
.opacity-80{
  opacity: 0.8;
}
.opacity-90{
  opacity: 0.9;
}
.opacity-95{
  opacity: 0.95;
}
.opacity-\\[60\\%\\]{
  opacity: 60%;
}
.shadow{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl{
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_2px_6px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.17\\)\\2c _0px_6px_18px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.1\\)\\]{
  --tw-shadow: 0px 2px 6px rgba(0,0,0,0.17), 0px 6px 18px rgba(0,0,0,0.1);
  --tw-shadow-colored: 0px 2px 6px var(--tw-shadow-color), 0px 6px 18px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-card{
  --tw-shadow: 0px 7px 30px -1px rgba(0,77,120,0.1);
  --tw-shadow-colored: 0px 7px 30px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-gray-400\\/50{
  --tw-shadow-color: rgb(156 163 175 / 0.5);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-slate-400{
  --tw-shadow-color: #94a3b8;
  --tw-shadow: var(--tw-shadow-colored);
}
.outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline{
  outline-style: solid;
}
.outline-0{
  outline-width: 0px;
}
.ring-4{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-\\[\\#C4E8E8\\]{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(196 232 232 / var(--tw-ring-opacity));
}
.ring-offset-0{
  --tw-ring-offset-width: 0px;
}
.brightness-50{
  --tw-brightness: brightness(.5);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[opacity\\]{
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity{
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform{
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-1000{
  transition-duration: 1000ms;
}
.duration-200{
  transition-duration: 200ms;
}
.duration-300{
  transition-duration: 300ms;
}
.ease-in-out{
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out{
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}

@font-face {
  font-family: 'wotfard';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'wotfard';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-weight: 600;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'wotfard';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'wotfard';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'wotfard';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}

/* ------------ Ant Design Overide for Date Picker ------------ */
.ant-space {
  width: 100%;
}
.ant-space-vertical {
  width: 100%;
  margin-bottom: 1rem;
}

.ant-space-item {
  width: 100%;
}

.ant-picker-input {
  width: 100%;
}

.ant-picker {
  padding: 1rem;
  border-radius: 10px;
  width: 100%;
  background-color: #e3f2f2;
  border: none;
}

.ant-picker:hover,
.ant-picker-focused {
  border-color: #f2f6f6;
  border-right-width: 1px;
}

/* ------------ Social login ------------ */
#googleIdLogin button,
#facebookIdLogin button {
  margin: 0 0 20px 0 !important;
  border-radius: 10px !important;
  box-shadow: none !important;
  width: 100% !important;
  height: 56px !important;
  /* padding: 0 !important; */
  font-size: 0.875rem !important;
}

#googleIdLogin button {
  border: 1px solid rgb(242 246 246 / var(--tw-border-opacity)) !important;
}

/* ------------ Slider ------------ */
.slick-slide > div {
  margin: 0 4px;
}

/* ------------ Phone Component ------------ */
.react-tel-input .form-control {
  font-size: 16px;
  background: #6ea7a600;
  border: none;
  border-radius: 10px;
  width: 100%;
  outline: none;
  padding: 15px 14px 15px 60px;
  transition: box-shadow ease 0.25s, border-color ease 0.25s;
  color: #000;
}

.react-tel-input .form-control:focus {
  background-color: #e3f2f2;
  border-color: none;
  outline: 0;
  box-shadow: 0 0 0 0;
}

.react-tel-input {
  background: #e3f2f2;
  border-radius: 10px;
}

.react-tel-input :disabled {
  background: #e9e9e9;
}

/* ------------ Camera Component Component ------------ */
#inner-circle {
  position: absolute;
  left: 40%;
  top: 40%;

  height: 60px;
  width: 60px;

  background: #7fe5e4 !important;
  border-radius: 50%;
  z-index: 2;
}

#outer-circle {
  left: -37px;
  height: 80px;
  width: 80px;
  background-color: #7fe5e46b !important;
  z-index: 1;
}

/** For tablet devices **/
@media (min-width: 768px) and (max-width: 1023px) {
  .custom-shape-divider-bottom-1655866819 svg {
    width: calc(127% + 1.3px);
    height: 80px;
  }
}

/** For mobile devices **/
@media (max-width: 767px) {
  .custom-shape-divider-bottom-1655866819 svg {
    width: calc(141% + 1.3px);
    height: 68px;
  }
}

.react-date-picker {
  display: inline-flex;
  font-size: 16px;
  line-height: 1;
  transition: 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
  height: 56px;
  position: relative;
  width: 100%;
  border-radius: 0.375rem;
  border-width: 0px;
  --tw-bg-opacity: 1;
  background-color: rgb(227 242 242 / var(--tw-bg-opacity));
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
  font-size: 1rem;
  line-height: 1.5rem;
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.react-date-picker:focus{
  --tw-border-opacity: 1;
  border-color: rgb(14 109 108 / var(--tw-border-opacity));
}

.react-date-picker__wrapper {
  display: flex;
  flex-grow: 1;
  flex-shrink: 0;
  border: none !important;
}

.react-date-picker__button svg {
  stroke: #8ab2b1;
}

.react-date-picker__inputGroup__input .react-date-picker__inputGroup__month {
  min-width: 30px;
}

.react-date-picker__inputGroup {
  min-width: calc((4px * 3) + 0.54em * 8 + 0.217em * 2);
  flex-grow: 1;
  padding: 0 2px;
  box-sizing: content-box;
}

.standard-h1 {
  color: #122224;
  margin-bottom: 32px;
  font-size: 40px;
  font-weight: 600;
  line-height: 40px;
}

.standard-h3 {
  margin-bottom: 30px;
  font-size: 20px;
  font-weight: 600;
}

.standard-para {
  font-size: 17px;
  margin-bottom: 30px;
}

.standard-para strong em {
  font-weight: 500;
}

.standard-h4 {
  -webkit-text-size-adjust: 100%;
  color: #122224;
  font-family: Wotfard, sans-serif;
  box-sizing: border-box;
  margin-top: 0;
  font-weight: 600;
  margin-bottom: 15px;
  font-size: 24px;
  line-height: 28.8px;
}

.b-read h1 {
  color: #122224;
  margin-bottom: 32px;
  font-size: 40px;
  font-weight: 600;
  line-height: 40px;
}

.b-read p {
  padding: 20px 0px;
}

.b-read p strong {
  font-size: 20px;
}

.b-read h3 strong {
  font-size: 22px;
  font-weight: 500;
}

.before\\:absolute::before{
  content: var(--tw-content);
  position: absolute;
}

.before\\:right-0::before{
  content: var(--tw-content);
  right: 0px;
}

.before\\:top-\\[50\\%\\]::before{
  content: var(--tw-content);
  top: 50%;
}

.before\\:block::before{
  content: var(--tw-content);
  display: block;
}

.before\\:h-\\[17px\\]::before{
  content: var(--tw-content);
  height: 17px;
}

.before\\:w-\\[2px\\]::before{
  content: var(--tw-content);
  width: 2px;
}

.before\\:translate-y-\\[-50\\%\\]::before{
  content: var(--tw-content);
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.before\\:bg-primaryDark::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(0 79 78 / var(--tw-bg-opacity));
}

.before\\:content-\\[\\'\\'\\]::before{
  --tw-content: '';
  content: var(--tw-content);
}

.last\\:mb-0:last-child{
  margin-bottom: 0px;
}

.last\\:before\\:content-none:last-child::before{
  --tw-content: none;
  content: var(--tw-content);
}

.hover\\:bg-\\[\\#E3F2F2\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(227 242 242 / var(--tw-bg-opacity));
}

.hover\\:bg-primaryDark:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(0 79 78 / var(--tw-bg-opacity));
}

.hover\\:bg-slate-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity));
}

.hover\\:text-primaryLight:hover{
  --tw-text-opacity: 1;
  color: rgb(127 229 228 / var(--tw-text-opacity));
}

.focus\\:border-primary:focus{
  --tw-border-opacity: 1;
  border-color: rgb(14 109 108 / var(--tw-border-opacity));
}

.focus\\:border-purple-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(168 85 247 / var(--tw-border-opacity));
}

.focus\\:bg-white:focus{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.focus\\:accent-primary:focus{
  accent-color: #0E6D6C;
}

.focus\\:outline-none:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:outline-0:focus{
  outline-width: 0px;
}

.focus\\:ring-0:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-2:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

@media (min-width: 640px){

  .sm\\:relative{
    position: relative;
  }

  .sm\\:block{
    display: block;
  }

  .sm\\:flex{
    display: flex;
  }

  .sm\\:hidden{
    display: none;
  }

  .sm\\:h-\\[10\\%\\]{
    height: 10%;
  }

  .sm\\:h-\\[15\\%\\]{
    height: 15%;
  }

  .sm\\:h-\\[18\\%\\]{
    height: 18%;
  }

  .sm\\:h-\\[20\\%\\]{
    height: 20%;
  }

  .sm\\:h-\\[30\\%\\]{
    height: 30%;
  }

  .sm\\:h-\\[40\\%\\]{
    height: 40%;
  }

  .sm\\:h-\\[520px\\]{
    height: 520px;
  }

  .sm\\:min-h-\\[80\\%\\]{
    min-height: 80%;
  }

  .sm\\:min-h-screen{
    min-height: 100vh;
  }

  .sm\\:w-\\[376px\\]{
    width: 376px;
  }

  .sm\\:w-\\[400px\\]{
    width: 400px;
  }

  .sm\\:w-\\[450px\\]{
    width: 450px;
  }

  .sm\\:w-\\[70\\%\\]{
    width: 70%;
  }

  .sm\\:w-\\[900px\\]{
    width: 900px;
  }

  .sm\\:w-full{
    width: 100%;
  }

  .sm\\:max-w-\\[376px\\]{
    max-width: 376px;
  }

  .sm\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:flex-row{
    flex-direction: row;
  }

  .sm\\:items-center{
    align-items: center;
  }

  .sm\\:justify-between{
    justify-content: space-between;
  }

  .sm\\:rounded-xl{
    border-radius: 0.75rem;
  }

  .sm\\:bg-\\[\\#E3F2F2\\]{
    --tw-bg-opacity: 1;
    background-color: rgb(227 242 242 / var(--tw-bg-opacity));
  }

  .sm\\:px-5{
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .sm\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:py-3{
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .sm\\:shadow-md{
    --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }

  .sm\\:shadow-primaryLight{
    --tw-shadow-color: #7FE5E4;
    --tw-shadow: var(--tw-shadow-colored);
  }
}

@media (min-width: 768px){

  .md\\:top-\\[-2px\\]{
    top: -2px;
  }

  .md\\:-mt-\\[80px\\]{
    margin-top: -80px;
  }

  .md\\:mb-0{
    margin-bottom: 0px;
  }

  .md\\:mb-\\[96px\\]{
    margin-bottom: 96px;
  }

  .md\\:ml-\\[63\\%\\]{
    margin-left: 63%;
  }

  .md\\:mt-0{
    margin-top: 0px;
  }

  .md\\:mt-6{
    margin-top: 1.5rem;
  }

  .md\\:block{
    display: block;
  }

  .md\\:flex{
    display: flex;
  }

  .md\\:grid{
    display: grid;
  }

  .md\\:hidden{
    display: none;
  }

  .md\\:h-\\[112px\\]{
    height: 112px;
  }

  .md\\:h-\\[120px\\]{
    height: 120px;
  }

  .md\\:h-\\[15\\%\\]{
    height: 15%;
  }

  .md\\:h-\\[288px\\]{
    height: 288px;
  }

  .md\\:h-\\[320px\\]{
    height: 320px;
  }

  .md\\:h-\\[360px\\]{
    height: 360px;
  }

  .md\\:h-\\[38px\\]{
    height: 38px;
  }

  .md\\:h-\\[40\\%\\]{
    height: 40%;
  }

  .md\\:w-4\\/5{
    width: 80%;
  }

  .md\\:w-96{
    width: 24rem;
  }

  .md\\:w-\\[100\\%\\]{
    width: 100%;
  }

  .md\\:w-\\[152px\\]{
    width: 152px;
  }

  .md\\:w-\\[214px\\]{
    width: 214px;
  }

  .md\\:w-\\[376px\\]{
    width: 376px;
  }

  .md\\:w-\\[40\\%\\]{
    width: 40%;
  }

  .md\\:w-\\[45\\%\\]{
    width: 45%;
  }

  .md\\:w-\\[480px\\]{
    width: 480px;
  }

  .md\\:w-\\[50\\%\\]{
    width: 50%;
  }

  .md\\:w-\\[570px\\]{
    width: 570px;
  }

  .md\\:w-\\[60\\%\\]{
    width: 60%;
  }

  .md\\:w-\\[80\\%\\]{
    width: 80%;
  }

  .md\\:w-\\[800px\\]{
    width: 800px;
  }

  .md\\:w-\\[86\\%\\]{
    width: 86%;
  }

  .md\\:w-\\[95\\%\\]{
    width: 95%;
  }

  .md\\:max-w-\\[376px\\]{
    max-width: 376px;
  }

  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:grid-cols-9{
    grid-template-columns: repeat(9, minmax(0, 1fr));
  }

  .md\\:flex-row{
    flex-direction: row;
  }

  .md\\:items-center{
    align-items: center;
  }

  .md\\:justify-between{
    justify-content: space-between;
  }

  .md\\:gap-12{
    gap: 3rem;
  }

  .md\\:gap-4{
    gap: 1rem;
  }

  .md\\:space-x-12 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(3rem * var(--tw-space-x-reverse));
    margin-left: calc(3rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .md\\:space-y-0 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }

  .md\\:rounded-2xl{
    border-radius: 1rem;
  }

  .md\\:rounded-lg{
    border-radius: 0.5rem;
  }

  .md\\:rounded-xl{
    border-radius: 0.75rem;
  }

  .md\\:bg-primaryLightBackground{
    --tw-bg-opacity: 1;
    background-color: rgb(227 242 242 / var(--tw-bg-opacity));
  }

  .md\\:px-\\[40px\\]{
    padding-left: 40px;
    padding-right: 40px;
  }

  .md\\:py-5{
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .md\\:py-\\[120px\\]{
    padding-top: 120px;
    padding-bottom: 120px;
  }

  .md\\:py-\\[38\\.5px\\]{
    padding-top: 38.5px;
    padding-bottom: 38.5px;
  }

  .md\\:pl-8{
    padding-left: 2rem;
  }

  .md\\:text-\\[17px\\]{
    font-size: 17px;
  }

  .md\\:text-\\[22px\\]{
    font-size: 22px;
  }

  .md\\:text-\\[24px\\]{
    font-size: 24px;
  }

  .md\\:text-\\[32px\\]{
    font-size: 32px;
  }

  .md\\:text-\\[40px\\]{
    font-size: 40px;
  }

  .md\\:leading-\\[28\\.8px\\]{
    line-height: 28.8px;
  }

  .md\\:leading-\\[48px\\]{
    line-height: 48px;
  }

  .md\\:shadow-card{
    --tw-shadow: 0px 7px 30px -1px rgba(0,77,120,0.1);
    --tw-shadow-colored: 0px 7px 30px -1px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }

  .md\\:shadow-none{
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }

  .md\\:shadow-primaryLight{
    --tw-shadow-color: #7FE5E4;
    --tw-shadow: var(--tw-shadow-colored);
  }
}

@media (min-width: 1024px){

  .lg\\:absolute{
    position: absolute;
  }

  .lg\\:relative{
    position: relative;
  }

  .lg\\:right-0{
    right: 0px;
  }

  .lg\\:top-\\[-70px\\]{
    top: -70px;
  }

  .lg\\:top-\\[-80px\\]{
    top: -80px;
  }

  .lg\\:z-10{
    z-index: 10;
  }

  .lg\\:order-1{
    order: 1;
  }

  .lg\\:order-2{
    order: 2;
  }

  .lg\\:m-auto{
    margin: auto;
  }

  .lg\\:mx-5{
    margin-left: 1.25rem;
    margin-right: 1.25rem;
  }

  .lg\\:mx-auto{
    margin-left: auto;
    margin-right: auto;
  }

  .lg\\:mb-\\[100px\\]{
    margin-bottom: 100px;
  }

  .lg\\:mb-\\[56px\\]{
    margin-bottom: 56px;
  }

  .lg\\:mb-\\[72px\\]{
    margin-bottom: 72px;
  }

  .lg\\:ml-5{
    margin-left: 1.25rem;
  }

  .lg\\:ml-\\[24px\\]{
    margin-left: 24px;
  }

  .lg\\:mr-0{
    margin-right: 0px;
  }

  .lg\\:mt-0{
    margin-top: 0px;
  }

  .lg\\:mt-8{
    margin-top: 2rem;
  }

  .lg\\:mt-\\[-9\\.5\\%\\]{
    margin-top: -9.5%;
  }

  .lg\\:mt-\\[80px\\]{
    margin-top: 80px;
  }

  .lg\\:block{
    display: block;
  }

  .lg\\:inline-block{
    display: inline-block;
  }

  .lg\\:flex{
    display: flex;
  }

  .lg\\:hidden{
    display: none;
  }

  .lg\\:h-16{
    height: 4rem;
  }

  .lg\\:h-\\[470px\\]{
    height: 470px;
  }

  .lg\\:h-\\[527px\\]{
    height: 527px;
  }

  .lg\\:h-\\[80px\\]{
    height: 80px;
  }

  .lg\\:w-\\[1200px\\]{
    width: 1200px;
  }

  .lg\\:w-\\[25\\%\\]{
    width: 25%;
  }

  .lg\\:w-\\[279px\\]{
    width: 279px;
  }

  .lg\\:w-\\[300px\\]{
    width: 300px;
  }

  .lg\\:w-\\[37\\%\\]{
    width: 37%;
  }

  .lg\\:w-\\[376px\\]{
    width: 376px;
  }

  .lg\\:w-\\[48\\%\\]{
    width: 48%;
  }

  .lg\\:w-\\[480px\\]{
    width: 480px;
  }

  .lg\\:w-\\[50\\%\\]{
    width: 50%;
  }

  .lg\\:w-\\[570px\\]{
    width: 570px;
  }

  .lg\\:w-\\[700px\\]{
    width: 700px;
  }

  .lg\\:w-\\[800px\\]{
    width: 800px;
  }

  .lg\\:w-\\[85\\%\\]{
    width: 85%;
  }

  .lg\\:w-\\[900px\\]{
    width: 900px;
  }

  .lg\\:w-auto{
    width: auto;
  }

  .lg\\:max-w-\\[376px\\]{
    max-width: 376px;
  }

  .lg\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:flex-row{
    flex-direction: row;
  }

  .lg\\:items-center{
    align-items: center;
  }

  .lg\\:overflow-x-visible{
    overflow-x: visible;
  }

  .lg\\:rounded-xl{
    border-radius: 0.75rem;
  }

  .lg\\:bg-primaryLightBackground{
    --tw-bg-opacity: 1;
    background-color: rgb(227 242 242 / var(--tw-bg-opacity));
  }

  .lg\\:px-0{
    padding-left: 0px;
    padding-right: 0px;
  }

  .lg\\:px-10{
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .lg\\:px-3{
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .lg\\:py-5{
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .lg\\:pb-0{
    padding-bottom: 0px;
  }

  .lg\\:pl-0{
    padding-left: 0px;
  }

  .lg\\:pr-0{
    padding-right: 0px;
  }

  .lg\\:pt-0{
    padding-top: 0px;
  }

  .lg\\:text-\\[20px\\]{
    font-size: 20px;
  }

  .lg\\:text-\\[36px\\]{
    font-size: 36px;
  }

  .lg\\:text-\\[72px\\]{
    font-size: 72px;
  }

  .lg\\:font-semibold{
    font-weight: 600;
  }

  .lg\\:leading-\\[72px\\]{
    line-height: 72px;
  }

  .lg\\:text-primaryDark{
    --tw-text-opacity: 1;
    color: rgb(0 79 78 / var(--tw-text-opacity));
  }

  .lg\\:shadow-card{
    --tw-shadow: 0px 7px 30px -1px rgba(0,77,120,0.1);
    --tw-shadow-colored: 0px 7px 30px -1px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }

  .lg\\:shadow-primaryLight{
    --tw-shadow-color: #7FE5E4;
    --tw-shadow: var(--tw-shadow-colored);
  }
}

@media (min-width: 1280px){

  .xl\\:mt-0{
    margin-top: 0px;
  }

  .xl\\:h-\\[220px\\]{
    height: 220px;
  }

  .xl\\:h-\\[250px\\]{
    height: 250px;
  }

  .xl\\:w-2\\/5{
    width: 40%;
  }

  .xl\\:w-\\[1200px\\]{
    width: 1200px;
  }

  .xl\\:w-\\[370px\\]{
    width: 370px;
  }
}

@media (min-width: 1536px){

  .\\32xl\\:w-\\[25\\%\\]{
    width: 25%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/index.css"],"names":[],"mappings":"AAAA,kCAAkC;;AAIlC,iEAAc;;AAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA,6CAAc;IAAd,eAAc;IAAd;AAAc;;AAAd;EAAA,oBAAc;EAAd;AAAc;;AAAd;EAAA,iBAAc;EAAd,sBAAc;EAAd,yDAAc;EAAd,kBAAc;EAAd,yDAAc;EAAd,oBAAc;EAAd,4CAAc;EAAd;AAAc;;AAAd;EAAA,2GAAc;EAAd,yGAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA,eAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AA2DlB,qCAAqC;AAEnC;EAAA,kBAA6C;EAA7C,aAA6C;EAA7C;AAA6C;AAA7C;EAAA;AAA6C;AAG/C;IACE,gBAAgB;IAChB,kBAAkB;EACpB;AACA;IACE,QAAQ,EAAE,2BAA2B;IACrC,uBAAuB,EAAE,4CAA4C;EACvE;AACA,6CAA6C;AAC7C;IACE,mBAAmB;EACrB;AAGE;EAAA,6CAAmB;IACnB,eAAe;IACf;AAFmB;AAMnB;EAAA,6CAAmB;IACnB,eAAe;IACf;AAFmB;AAKrB;IACE,oBAAoB;IACpB,sCAAsC;IACtC,0BAA0B;IAC1B,gDAAgD;IAChD,kBAA8D;IAA9D,UAA8D;IAA9D,eAA8D;IAA9D,mBAA8D;IAA9D,wBAA8D;EAChE;AAEA;IACE,eAAe;IACf,cAAc;IACd,gDAAgD;IAChD,YAAY;IAEZ,kBAA6G;IAA7G,WAA6G;IAA7G,uBAA6G;IAA7G,iBAA6G;IAA7G,kBAA6G;IAA7G,yDAA6G;IAA7G,qBAA6G;IAA7G,sBAA6G;IAA7G,iBAA6G;IAA7G,oBAA6G;IAA7G,eAA6G;IAA7G,mBAA6G;IAA7G,8BAA6G;IAA7G,mBAA6G;EAC/G;AADE;EAAA,sBAA6G;EAA7G;AAA6G;AAG/G;IACE,yBAAyB;EAC3B;AAEA;IACE,eAAe;IACf,cAAc;IACd,gDAAgD;IAChD,YAAY;IAEZ,kBAAwH;IAAxH,WAAwH;IAAxH,uBAAwH;IAAxH,iBAAwH;IAAxH,oCAAwH;IAAxH,qBAAwH;IAAxH,sBAAwH;IAAxH,iBAAwH;IAAxH,oBAAwH;IAAxH,eAAwH;IAAxH,mBAAwH;IAAxH,8BAAwH;IAAxH,mBAAwH;EAC1H;AADE;EAAA,sBAAwH;EAAxH;AAAwH;AAIxH;EAAA,iBAAyB;EAAzB;AAAyB;AAG3B;EACA;AAEA;;IAEE,uCAAuC;EACzC;AAGE;EAAA,iBAAyB;EAAzB;AAAyB;AAE3B;;;;IAIE,uCAAuC;EACzC;AAKE;;;;EAAA,iBAAyB;EAAzB;AAAyB;AAIzB;EAAA,kBAAsG;EAAtG,QAAsG;EAAtG,WAAsG;EAAtG,UAAsG;EAAtG,aAAsG;EAAtG,eAAsG;EAAtG,mBAAsG;EAAtG,sBAAsG;EAAtG,mBAAsG;EAAtG,oBAAsG;EAAtG,oBAAsG;EAAtG;AAAsG;AAGxG,sCAAsC;AAGpC;;EAAA,qBAAsI;EAAtI,mBAAsI;EAAtI,iBAAsI;EAAtI,sBAAsI;EAAtI,wDAAsI;EAAtI,qBAAsI;EAAtI,sBAAsI;EAAtI,gBAAsI;EAAtI,mBAAsI;EAAtI,kBAAsI;EAAtI,mBAAsI;EAAtI,oBAAsI;EAAtI,gBAAsI;EAAtI,iBAAsI;EAAtI,oBAAsI;EAAtI;AAAsI;AAExI;;IAEE,YAAY;EACd;AAEE;EAAA,WAAqC;EAArC;AAAqC;AAArC;;EAAA;IAAA,kBAAqC;IAArC;EAAqC;AAAA;AAIrC;EAAA,kBAA4B;EAA5B,wDAA4B;EAA5B,oBAA4B;EAA5B;AAA4B;AAI5B;EAAA,sBAA4B;EAA5B,yDAA4B;EAA5B,kBAA4B;EAA5B;AAA4B;AAG5B;EAAA;AAAiC;AAOjC;EAAA,uEAA0E;EAA1E,4FAA0E;EAA1E;AAA0E;AAG3E;IACC,IAAI;EACN;AAEA,qCAAqC;AAyBrC,yCAAyC;AAEvC;EAAA,kBAAmI;EAAnI,mBAAmI;EAAnI,aAAmI;EAAnI,YAAmI;EAAnI,WAAmI;EAAnI,mBAAmI;EAAnI,uBAAmI;EAAnI,kBAAmI;EAAnI,eAAmI;EAAnI,gBAAmI;EAAnI,oBAAmI;EAAnI;AAAmI;AAGrI,qCAAqC;AACrC;IACE,gBAAgB;IAChB,kBAAkB;EACpB;AAEA,6CAA6C;AAmB7C;IACE,cAAc;EAChB;AACA;IACE,mBAAmB;EACrB;AACA,yCAAyC;AACzC;IACE,wCAAwC;EAC1C;AACA;IACE,WAAW;IACX,oCAAoC;EACtC;AAEA;IACE,WAAW;IACX,oCAAoC;EACtC;AAEA;;IAEE,oCAAoC;EACtC;AA2BA,uCAAuC;AACvC;IACE,kBAAkB;EACpB;AACA;IACE,cAAc;EAChB;AACA;IACE,kBAAkB;IAClB,OAAO;IACP,aAAa;EACf;AACA;IACE,kBAAkB;IAClB,cAAc;EAChB;AACA;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,OAAO;IACP,sCAAsC;IACtC,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,WAAW;IACX,YAAY;IACZ,gCAAgC;EAClC;AACA;IACE,mBAAmB;EACrB;AAEA;IACE,iBAAiB;EACnB;AAtUF;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uEAAmB;EAAnB,4FAAmB;EAAnB;AAAmB;AAAnB;EAAA,iDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gKAAmB;EAAnB,wJAAmB;EAAnB,iLAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB;EACE,sBAAsB;EACtB,4CAA8D;EAC9D,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,4CAAkE;EAClE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,4CAAgE;EAChE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,4CAAiE;EACjE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,4CAA+D;EAC/D,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAiSA,iEAAiE;AACjE;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,YAAY;AACd;;AAEA;;EAEE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA,2CAA2C;AAC3C;;EAEE,6BAA6B;EAC7B,8BAA8B;EAC9B,2BAA2B;EAC3B,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,wEAAwE;AAC1E;;AAEA,qCAAqC;AACrC;EACE,aAAa;AACf;;AAEA,8CAA8C;AAC9C;EACE,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,4BAA4B;EAC5B,0DAA0D;EAC1D,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yDAAyD;AACzD;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;;EAER,YAAY;EACZ,WAAW;;EAEX,8BAA8B;EAC9B,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,sCAAsC;EACtC,UAAU;AACZ;;AAEA,yBAAyB;AACzB;EACE;IACE,yBAAyB;IACzB,YAAY;EACd;AACF;;AAEA,yBAAyB;AACzB;EACE;IACE,yBAAyB;IACzB,YAAY;EACd;AACF;;AAEA;EACE,oBAAoB;EAGpB,eAAe;EACf,cAAc;EACd,gDAAgD;EAChD,YAAY;EAEZ,kBAA6G;EAA7G,WAA6G;EAA7G,uBAA6G;EAA7G,iBAA6G;EAA7G,kBAA6G;EAA7G,yDAA6G;EAA7G,qBAA6G;EAA7G,sBAA6G;EAA7G,iBAA6G;EAA7G,oBAA6G;EAA7G,eAA6G;EAA7G,mBAA6G;EAA7G,8BAA6G;EAA7G,mBAA6G;AAC/G;;AADE;EAAA,sBAA6G;EAA7G;AAA6G;;AAG/G;EACE,aAAa;EACb,YAAY;EACZ,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,gCAAgC;EAChC,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AA9hBA;EAAA,0BA+hBA;EA/hBA;AA+hBA;;AA/hBA;EAAA,0BA+hBA;EA/hBA;AA+hBA;;AA/hBA;EAAA,0BA+hBA;EA/hBA;AA+hBA;;AA/hBA;EAAA,0BA+hBA;EA/hBA;AA+hBA;;AA/hBA;EAAA,0BA+hBA;EA/hBA;AA+hBA;;AA/hBA;EAAA,0BA+hBA;EA/hBA;AA+hBA;;AA/hBA;EAAA,0BA+hBA;EA/hBA,sBA+hBA;EA/hBA;AA+hBA;;AA/hBA;EAAA,0BA+hBA;EA/hBA,kBA+hBA;EA/hBA;AA+hBA;;AA/hBA;EAAA,gBA+hBA;EA/hBA;AA+hBA;;AA/hBA;EAAA;AA+hBA;;AA/hBA;EAAA,kBA+hBA;EA/hBA;AA+hBA;;AA/hBA;EAAA,kBA+hBA;EA/hBA;AA+hBA;;AA/hBA;EAAA,kBA+hBA;EA/hBA;AA+hBA;;AA/hBA;EAAA,kBA+hBA;EA/hBA;AA+hBA;;AA/hBA;EAAA,oBA+hBA;EA/hBA;AA+hBA;;AA/hBA;EAAA,sBA+hBA;EA/hBA;AA+hBA;;AA/hBA;EAAA,sBA+hBA;EA/hBA;AA+hBA;;AA/hBA;EAAA,kBA+hBA;EA/hBA;AA+hBA;;AA/hBA;EAAA;AA+hBA;;AA/hBA;EAAA,8BA+hBA;EA/hBA;AA+hBA;;AA/hBA;EAAA;AA+hBA;;AA/hBA;EAAA,2GA+hBA;EA/hBA,yGA+hBA;EA/hBA;AA+hBA;;AA/hBA;EAAA,2GA+hBA;EA/hBA,yGA+hBA;EA/hBA;AA+hBA;;AA/hBA;;EAAA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA,kBA+hBA;IA/hBA;EA+hBA;;EA/hBA;IAAA,qBA+hBA;IA/hBA;EA+hBA;;EA/hBA;IAAA,oBA+hBA;IA/hBA;EA+hBA;;EA/hBA;IAAA,oBA+hBA;IA/hBA;EA+hBA;;EA/hBA;IAAA,6EA+hBA;IA/hBA,iGA+hBA;IA/hBA;EA+hBA;;EA/hBA;IAAA,0BA+hBA;IA/hBA;EA+hBA;AAAA;;AA/hBA;;EAAA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA,uBA+hBA;IA/hBA,oDA+hBA;IA/hBA;EA+hBA;;EA/hBA;IAAA,uBA+hBA;IA/hBA,2DA+hBA;IA/hBA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA,kBA+hBA;IA/hBA;EA+hBA;;EA/hBA;IAAA,kBA+hBA;IA/hBA;EA+hBA;;EA/hBA;IAAA,oBA+hBA;IA/hBA;EA+hBA;;EA/hBA;IAAA,kBA+hBA;IA/hBA;EA+hBA;;EA/hBA;IAAA,mBA+hBA;IA/hBA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA,iDA+hBA;IA/hBA,6DA+hBA;IA/hBA;EA+hBA;;EA/hBA;IAAA,sBA+hBA;IA/hBA,8BA+hBA;IA/hBA;EA+hBA;;EA/hBA;IAAA,0BA+hBA;IA/hBA;EA+hBA;AAAA;;AA/hBA;;EAAA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA,oBA+hBA;IA/hBA;EA+hBA;;EA/hBA;IAAA,iBA+hBA;IA/hBA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA,kBA+hBA;IA/hBA;EA+hBA;;EA/hBA;IAAA,iBA+hBA;IA/hBA;EA+hBA;;EA/hBA;IAAA,oBA+hBA;IA/hBA;EA+hBA;;EA/hBA;IAAA,qBA+hBA;IA/hBA;EA+hBA;;EA/hBA;IAAA,oBA+hBA;IA/hBA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA,oBA+hBA;IA/hBA;EA+hBA;;EA/hBA;IAAA,iDA+hBA;IA/hBA,6DA+hBA;IA/hBA;EA+hBA;;EA/hBA;IAAA,0BA+hBA;IA/hBA;EA+hBA;AAAA;;AA/hBA;;EAAA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;;EA/hBA;IAAA;EA+hBA;AAAA;;AA/hBA;;EAAA;IAAA;EA+hBA;AAAA","sourcesContent":["/* eslint-disable unknownAtRules */\n\n@import url('https://fonts.googleapis.com/css2?family=Martel+Sans:wght@300;400;700;800&display=swap');\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@font-face {\n  font-family: 'wotfard';\n  src: url('../../public/assets/fonts/Wotfard/Wotfard-Bold.otf');\n  font-weight: 700;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'wotfard';\n  src: url('../../public/assets/fonts/Wotfard/Wotfard-SemiBold.otf');\n  font-weight: 600;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'wotfard';\n  src: url('../../public/assets/fonts/Wotfard/Wotfard-Medium.otf');\n  font-weight: 500;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'wotfard';\n  src: url('../../public/assets/fonts/Wotfard/Wotfard-Regular.otf');\n  font-weight: 400;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'wotfard';\n  src: url('../../public/assets/fonts/Wotfard/Wotfard-Light.otf');\n  font-weight: 300;\n  font-style: normal;\n  font-display: swap;\n}\n\n@layer base {\n  body {\n    @apply font-wotfard;\n    font-size: 1rem;\n    line-height: 1.5rem;\n  }\n  a:visited {\n    @apply text-primaryDark;\n  }\n\n  [type='radio'] {\n    @apply text-primaryDark bg-white border-2 border-[#E3F2F2] focus:ring-0 ring-offset-0;\n  }\n}\n\n@layer components {\n  /* ------------ Inputs ------------ */\n  .form-group {\n    @apply relative flex flex-col focus:outline-0;\n  }\n\n  html {\n    overflow: scroll;\n    overflow-x: hidden;\n  }\n  ::-webkit-scrollbar {\n    width: 0; /* Remove scrollbar space */\n    background: transparent; /* Optional: just make scrollbar invisible */\n  }\n  /* Optional: show position indicator in red */\n  ::-webkit-scrollbar-thumb {\n    background: #ff0000;\n  }\n\n  input:-webkit-autofill::first-line {\n    @apply font-wotfard;\n    font-size: 16px;\n    font-weight: 400;\n  }\n\n  select:-webkit-autofill::first-line {\n    @apply font-wotfard;\n    font-size: 16px;\n    font-weight: 400;\n  }\n\n  .form-group label {\n    pointer-events: none;\n    transform: translate(0, 15px) scale(1);\n    transform-origin: top left;\n    transition: 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;\n    @apply absolute text-[rgba(0,79,78,0.6)] left-[12px] text-base;\n  }\n\n  .form-group input {\n    font-size: 16px;\n    line-height: 1;\n    transition: 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;\n    height: 56px;\n\n    @apply px-3 py-4 relative bg-[#E3F2F2] rounded-md text-base border-0 outline-none w-full focus:border-primary;\n  }\n\n  .form-group :disabled {\n    background-color: #e9e9e9;\n  }\n\n  .form-group select {\n    font-size: 16px;\n    line-height: 1;\n    transition: 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;\n    height: 56px;\n\n    @apply px-3 py-4 relative bg-[rgba(0,79,78,0.05)] rounded-md text-base border-0 outline-none w-full focus:border-primary;\n  }\n\n  .form-group:focus-within input {\n    @apply pt-[25px] pb-[7px];\n  }\n\n  .form-group:focus-within select {\n  }\n\n  .form-group.form-group--filled label,\n  .form-group:focus-within label {\n    transform: translate(0, 4px) scale(0.7);\n  }\n\n  .form-group.form-group--filled input {\n    @apply pt-[25px] pb-[7px];\n  }\n  .form-group input:-webkit-autofill + label,\n  .form-group input:-webkit-autofill:hover + label,\n  .form-group input:-webkit-autofill:focus + label,\n  .form-group input:-webkit-autofill:active + label {\n    transform: translate(0, 4px) scale(0.7);\n  }\n  .form-group input:-webkit-autofill,\n  .form-group input:-webkit-autofill:hover,\n  .form-group input:-webkit-autofill:focus,\n  .form-group input:-webkit-autofill:active {\n    @apply pt-[25px] pb-[7px];\n  }\n\n  .password-visible {\n    @apply cursor-pointer absolute inset-y-0 right-0 pr-3 flex items-center text-sm leading-5 text-primary;\n  }\n\n  /* ------------ Buttons ------------ */\n  button,\n  .btn {\n    @apply text-sm leading-[14px] text-primary border-primary font-semibold border-2 px-3 py-[9px] rounded-[10px] inline-block text-center;\n  }\n  button:disabled,\n  .btn:disabled {\n    opacity: 0.6;\n  }\n  .btn--big {\n    @apply w-[100%] p-[19px] lg:px-[40px];\n  }\n\n  .btn--dark {\n    @apply bg-primary text-white;\n  }\n\n  .btn--white {\n    @apply bg-white border-white;\n  }\n  .btn--gray {\n    @apply border-[rgba(0,79,78,0.2)];\n  }\n  .btn--full {\n    @apply w-[100%];\n  }\n\n  .btn--shadow {\n    @apply shadow-[0px_2px_6px_rgba(0,0,0,0.17),_0px_6px_18px_rgba(0,0,0,0.1)];\n  }\n\n   {\n    /* */\n  }\n\n  /* ------------ Alerts ------------ */\n  .notificationWrapper {\n    @apply flex flex-row items-center justify-between w-96 bg-gray-900 px-4 py-6 text-white shadow-2xl hover:shadow-none transform-gpu translate-y-0 hover:translate-y-1 rounded-xl relative transition-all duration-500 ease-in-out;\n  }\n\n  .iconWrapper {\n    @apply text-xl;\n  }\n\n  .contentWrapper {\n    @apply flex flex-col items-start justify-center ml-4 cursor-default;\n  }\n\n  .contentWrapper h1 {\n    @apply text-base text-gray-200 font-semibold leading-none tracking-wider;\n  }\n\n  .contentWrapper p {\n    @apply text-sm text-gray-400 mt-2 leading-relaxed tracking-wider;\n  }\n\n  .closeIcon {\n    @apply absolute top-2 right-2 cursor-pointer text-lg;\n  }\n\n  /* ------------ Typography ------------ */\n  .fullpage-title {\n    @apply w-[100%] h-[36px] relative flex items-center justify-center text-[18px] text-primaryDark text-center font-semibold mb-[30px];\n  }\n\n  /* ------------ SignUp ------------ */\n  .signup-description {\n    font-weight: 500;\n    margin: 0 0 32px 0;\n  }\n\n  /* ------------ Password check ------------ */\n  .password-check {\n    @apply text-[14px];\n  }\n  .password-check p {\n    @apply mb-[10px];\n  }\n  .password-check ul {\n    list-style: none;\n    @apply m-0 p-0;\n  }\n  .password-check li {\n    @apply relative min-h-[16px] pl-[24px] leading-[14px] mb-[20px];\n  }\n  .password-check li:before {\n    content: '';\n    @apply w-[8px] h-[8px] block bg-[#ff7a00] rounded-[50%] absolute top-[40%] left-0 translate-y-[-50%];\n  }\n\n  .password-check li.active {\n    color: #3eb76e;\n  }\n  .password-check li.active:before {\n    background: #3eb76e;\n  }\n  /* ------------ Datepicker ------------ */\n  .root {\n    background-color: '#0b6463f2' !important;\n  }\n  .css-3eghsz-PrivatePickersYear-button.Mui-selected {\n    color: #fff;\n    background-color: #004f4e !important;\n  }\n\n  .css-15fehp8-MuiTypography-root-PrivatePickersMonth-root.Mui-selected {\n    color: #fff;\n    background-color: #004f4e !important;\n  }\n\n  .css-1hy66ry-MuiPaper-root-MuiPickersPopper-paper\n    .MuiPickersDay-root.Mui-selected {\n    background-color: #004f4e !important;\n  }\n\n  .datePicker {\n    margin-bottom: 16px;\n    position: relative;\n  }\n  .datePicker:before {\n    content: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iNyIgdmlld0JveD0iMCAwIDEyIDciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xMS42NzA2IDEuOTkwNjNMNi44OTQzNyA2LjY1NzI5QzYuNjI3NTcgNi44ODY5OCA2LjMxOTQyIDcgNi4wMTEyOCA3QzUuNzAzMTQgNyA1LjM5NTc1IDYuODg2MDcgNS4xNjA4OSA2LjY1ODJMMC4zODQ3MDEgMS45OTE1NEMwLjAwNzIwNTY3IDEuNjU4ODUgLTAuMDk1NzczNiAxLjE1NTczIDAuMDkwMzg4NyAwLjcyMTg3NUMwLjI3NjU1MSAwLjI4ODAyMSAwLjcxNTM4OSAwIDEuMjAxMjggMEgxMC43ODc1QzExLjI3MzcgMCAxMS43MTI2IDAuMjgzNjgyIDExLjg5OSAwLjcyMDA1MkMxMi4wODU0IDEuMTU2NDIgMTIuMDE2MyAxLjY1ODg1IDExLjY3MDYgMS45OTA2M1oiIGZpbGw9IiMwMDRGNEUiLz4KPC9zdmc+Cg==');\n    display: block;\n    position: absolute;\n    top: 50%;\n    right: 18px;\n    transform: translateY(-50%);\n  }\n\n  .datePicker input {\n    height: 56px;\n    padding: 12px;\n    background: rgba(0, 79, 78, 0.05);\n    border-radius: 10px;\n    width: 100%;\n    color: rgba(0, 79, 78, 0.6);\n    font-weight: 400;\n    font-size: 16px;\n    border-radius: 10px;\n    line-height: 150%;\n  }\n  /* ------------ Checkbox ------------ */\n  .checkbox {\n    position: relative;\n  }\n  .checkbox a {\n    color: #0e6d6c;\n  }\n  .checkbox input[type='checkbox'] {\n    position: absolute;\n    left: 0;\n    opacity: 0.01;\n  }\n  .checkbox input[type='checkbox'] + label {\n    padding-left: 30px;\n    display: block;\n  }\n  .checkbox input[type='checkbox'] + label:before {\n    content: '';\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    left: 0;\n    border: 2px solid rgba(0, 79, 78, 0.4);\n    border-radius: 5px;\n    cursor: pointer;\n    display: block;\n    width: 18px;\n    height: 18px;\n    transition: all 0.2s ease-in-out;\n  }\n  .checkbox input[type='checkbox']:checked + label:before {\n    background: #0e6d6c;\n  }\n\n  .checkbox input[type='checkbox'] + label {\n    margin-right: 4px;\n  }\n}\n\n/* ------------ Ant Design Overide for Date Picker ------------ */\n.ant-space {\n  width: 100%;\n}\n.ant-space-vertical {\n  width: 100%;\n  margin-bottom: 1rem;\n}\n\n.ant-space-item {\n  width: 100%;\n}\n\n.ant-picker-input {\n  width: 100%;\n}\n\n.ant-picker {\n  padding: 1rem;\n  border-radius: 10px;\n  width: 100%;\n  background-color: #e3f2f2;\n  border: none;\n}\n\n.ant-picker:hover,\n.ant-picker-focused {\n  border-color: #f2f6f6;\n  border-right-width: 1px;\n}\n\n/* ------------ Social login ------------ */\n#googleIdLogin button,\n#facebookIdLogin button {\n  margin: 0 0 20px 0 !important;\n  border-radius: 10px !important;\n  box-shadow: none !important;\n  width: 100% !important;\n  height: 56px !important;\n  /* padding: 0 !important; */\n  font-size: 0.875rem !important;\n}\n\n#googleIdLogin button {\n  border: 1px solid rgb(242 246 246 / var(--tw-border-opacity)) !important;\n}\n\n/* ------------ Slider ------------ */\n.slick-slide > div {\n  margin: 0 4px;\n}\n\n/* ------------ Phone Component ------------ */\n.react-tel-input .form-control {\n  font-size: 16px;\n  background: #6ea7a600;\n  border: none;\n  border-radius: 10px;\n  width: 100%;\n  outline: none;\n  padding: 15px 14px 15px 60px;\n  transition: box-shadow ease 0.25s, border-color ease 0.25s;\n  color: #000;\n}\n\n.react-tel-input .form-control:focus {\n  background-color: #e3f2f2;\n  border-color: none;\n  outline: 0;\n  box-shadow: 0 0 0 0;\n}\n\n.react-tel-input {\n  background: #e3f2f2;\n  border-radius: 10px;\n}\n\n.react-tel-input :disabled {\n  background: #e9e9e9;\n}\n\n/* ------------ Camera Component Component ------------ */\n#inner-circle {\n  position: absolute;\n  left: 40%;\n  top: 40%;\n\n  height: 60px;\n  width: 60px;\n\n  background: #7fe5e4 !important;\n  border-radius: 50%;\n  z-index: 2;\n}\n\n#outer-circle {\n  left: -37px;\n  height: 80px;\n  width: 80px;\n  background-color: #7fe5e46b !important;\n  z-index: 1;\n}\n\n/** For tablet devices **/\n@media (min-width: 768px) and (max-width: 1023px) {\n  .custom-shape-divider-bottom-1655866819 svg {\n    width: calc(127% + 1.3px);\n    height: 80px;\n  }\n}\n\n/** For mobile devices **/\n@media (max-width: 767px) {\n  .custom-shape-divider-bottom-1655866819 svg {\n    width: calc(141% + 1.3px);\n    height: 68px;\n  }\n}\n\n.react-date-picker {\n  display: inline-flex;\n  position: relative;\n  width: 100%;\n  font-size: 16px;\n  line-height: 1;\n  transition: 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;\n  height: 56px;\n\n  @apply px-3 py-4 relative bg-[#E3F2F2] rounded-md text-base border-0 outline-none w-full focus:border-primary;\n}\n\n.react-date-picker__wrapper {\n  display: flex;\n  flex-grow: 1;\n  flex-shrink: 0;\n  border: none !important;\n}\n\n.react-date-picker__button svg {\n  stroke: #8ab2b1;\n}\n\n.react-date-picker__inputGroup__input .react-date-picker__inputGroup__month {\n  min-width: 30px;\n}\n\n.react-date-picker__inputGroup {\n  min-width: calc((4px * 3) + 0.54em * 8 + 0.217em * 2);\n  flex-grow: 1;\n  padding: 0 2px;\n  box-sizing: content-box;\n}\n\n.standard-h1 {\n  color: #122224;\n  margin-bottom: 32px;\n  font-size: 40px;\n  font-weight: 600;\n  line-height: 40px;\n}\n\n.standard-h3 {\n  margin-bottom: 30px;\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.standard-para {\n  font-size: 17px;\n  margin-bottom: 30px;\n}\n\n.standard-para strong em {\n  font-weight: 500;\n}\n\n.standard-h4 {\n  -webkit-text-size-adjust: 100%;\n  color: #122224;\n  font-family: Wotfard, sans-serif;\n  box-sizing: border-box;\n  margin-top: 0;\n  font-weight: 600;\n  margin-bottom: 15px;\n  font-size: 24px;\n  line-height: 28.8px;\n}\n\n.b-read h1 {\n  color: #122224;\n  margin-bottom: 32px;\n  font-size: 40px;\n  font-weight: 600;\n  line-height: 40px;\n}\n\n.b-read p {\n  padding: 20px 0px;\n}\n\n.b-read p strong {\n  font-size: 20px;\n}\n\n.b-read h3 strong {\n  font-size: 22px;\n  font-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
